<div class="container-fluid">
    <div class="container max-w-h banner my-2">
        <div class="bg-banner">
            <div class="d-flex flex-column">
                <img class="pdf-logo" src="../../../../assets/new-logo/SCBCLOGO-COLOR.svg" alt="loading">
                <div class="p-3rem">
                    <div class="bar pos-rel-pdf">
                        <div class="d-flex pos-abs-pdf">
                            <div class="circle-dot"></div>
                            <div class="circle-dot"></div>
                            <div class="circle-dot"></div>
                        </div>
                        خدمات وزارة االسـتثمار
                    </div>
                    <div class="d-flex justify-content-end">
                        <div class="blue-box">جميع الحقوق محفوظة</div>
                        <div class="sky-box">جميع الحقوق محفوظة</div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="container max-w-h banner my-2">
        <div class="bg-banner-2">
            <div class="d-flex flex-column p-adjustment">
                <div class="d-flex">
                    <div class="d-flex align-items-center m-left">
                        <img class="less" src="../../../../assets/pngegg.png" alt="loading">
                        <div class="circle-2"></div>
                        <div class="circle-2"></div>
                        <div class="circle-2"></div>
                    </div>
                    <h6 class="pdf-heading">حقوق الملكية الفكرية ©</h6>
                </div>
                <p class="pdf-text">حقــوق الملكيــة الفكريــة محفوظــة للمركــز الســعودي لألعمــال االقتصاديــة،
                    ويحظــر
                    االعتـداء عليهـا بـأي شـكل مـن األشـكال المخالفـة لنظـام حمايـة حقـوق المؤلـف وحمايـة
                    الملكيـة الفكريـة.</p>
            </div>
        </div>
    </div>

    <div class="container max-w-h banner my-2">
        <div class="bg-banner-2 bg-blue d-flex justify-content-center align-items-center">
            <img class="vector" src="../../../../assets/Vector.png" alt="loading">
        </div>
    </div>

    <div class="container max-w-h bg-white-pdf my-2">
        <div class="p-pdf-bottom">
            <div class="px-6rem">
                <div class="d-flex">
                    <img class="pdf-page-logo" src="../../../../assets/new-logo/SCBCLOGO-COLOR.svg" alt="loading">
                    <div class="b-bottom"></div>
                </div>
                <h6 class="pdf-heading my-5">تعريف بالمركز السعودي لألعمال االقتصادية </h6>
                <p class="pdf-text mb-3rem">مركـز يعنـى بتيسـير إجـراءات بـدء األعمـال االقتصاديـة ومزاولتهـا وإنهائهـا
                    وتقديـم
                    جميـع الخدمـات واألعمـال
                    ذات الصلـة بهـا وفقً ـا ألفضـل الممارسـات الدوليـة.
                    تـم تأسـيس المركـز بموجـب قـرار مجلـس الـوزراء رقـم )456(، الصـادر بتاريـخ 11 شـعبان 1440هــ، الـذي
                    نـص
                    ً علـى تأسـيس المركـز السـعودي لألعمـال االقتصاديـة واعتمـاد تنظيمـه، وبموجبـه يرتبـط تنظيميـا
                    بمجلـس
                    الشـؤون االقتصاديـة والتنميـة.</p>
                <h6 class="pdf-heading-sky">الـــــــــــرؤية:</h6>
                <p class="pdf-text mb-3rem">أن تصبـح المملكـة العربيـة السـعودية إحـدى الـدول العشـر الرائـدة فـي
                    العالـم مـن
                    خـل جـودة وسالسـة
                    وكفــاءة الخدمــات الحكوميــة الموجهــة لقطــاع األعمــال.</p>
                <h6 class="pdf-heading-sky">الرسالة:</h6>
                <p class="pdf-text">خلـق بيئـة أعمـال جاذبـة وتقديـم نمـوذج خدمـات يعـزز القـدرة التنافسـية واالسـتثمار
                    والنمـو
                    فـي المملكـة
                    العربيـة السـعودية.</p>
                <div class="d-flex flex-column w-100 mtt-3rem">
                    <div class="d-flex pen-box">
                        <img class="pen-icon" src="../../../../assets/icons/SBC/penpaper.svg" alt="loading">
                        <h6 class="pdf-heading pen-icon-bar">إرشادات المدرب</h6>
                    </div>
                    <div class="pos-rel-pdf">
                        <div class="pen-pos-abs">
                            <div class="pen-blue-box">
                                <div class="pdf-pos-rel">
                                    <div class="pdf-pos-abs-dot">
                                    </div>
                                    <p class="pdf-text-white">اعـرض شـريحة التعريـف بالمركـز السـعودي لألعمـال
                                        االقتصاديـة، ووضـح
                                        للمشـاركين ماهيـة
                                        المركـز ورؤيتـه وأهميتـه.</p>
                                </div>
                                <div class="pdf-pos-rel">
                                    <div class="pdf-pos-abs-dot">
                                    </div>
                                    <p class="pdf-text-white">اعـرض شـريحة التعريـف بالمركـز السـعودي لألعمـال
                                        االقتصاديـة، ووضـح
                                        للمشـاركين ماهيـة
                                        المركـز ورؤيتـه وأهميتـهلألعمـال االقتصاديـة، ووضـح للمشـاركين ماهيـة.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="container max-w-h bg-white-pdf my-2">
        <div class="p-pdf-bottom">
            <div class="px-6rem">
                <div class="d-flex my-3">
                    <div class="b-bottom"></div>
                    <p class="pdf-text-desc">خدمات وزارة االسـتثمار</p>
                </div>
                <div class="d-flex justify-content-center">
                    <h6 class="pdf-heading my-5">شكر وترحيب</h6>
                </div>
                <p class="pdf-text mb-3rem">يتقـدم المركـز السـعودي لألعمـال االقتصاديـة بالشـكر والترحيـب بالمشـاركين
                    فـي
                    البرنامـج التدريبـي، كمـا
                    َّ يتمنـى لهـم االسـتفادة الفاعلـة منـه، آمليـن أن ينعكـس أثـر هـذا التدريـب علـى جـودة الخدمـات
                    المقدمـة مـن
                    َقِ ب ً ـل المركـز السـعودي لألعمـال االقتصاديـة، وأن يشـكل دور ً ا حقيقيـا فـي تطويـر رؤيتـه،
                    ورسـالته،
                    وأهدافـه،
                    وأن يقـدم خدمـة شـاملة للمسـتثمرين تسـاهم فـي تحقيـق رؤيـة المملكـة 2030م بعـون اللـه تعالـى.</p>
                <div class="d-flex justify-content-center my-5">
                    <p class="pdf-black">والله ولي التوفيق</p>
                </div>
                <div class="d-flex justify-content-end">
                    <p class="pdf-black">فريق العمل</p>
                </div>
                <div class="d-flex flex-column w-100 mtt-3rem">
                    <div class="d-flex pen-box">
                        <img class="pen-icon" src="../../../../assets/icons/SBC/penpaper.svg" alt="loading">
                        <h6 class="pdf-heading pen-icon-bar">إرشادات المدرب</h6>
                    </div>
                    <div class="pos-rel-pdf">
                        <div class="pen-pos-abs">
                            <div class="pen-blue-box">
                                <div class="pdf-pos-rel">
                                    <div class="pdf-pos-abs-dot">
                                    </div>
                                    <p class="pdf-text-white">اعـرض شـريحة التعريـف بالمركـز السـعودي لألعمـال
                                        االقتصاديـة، ووضـح
                                        للمشـاركين ماهيـة
                                        المركـز ورؤيتـه وأهميتـه.</p>
                                </div>
                                <div class="pdf-pos-rel">
                                    <div class="pdf-pos-abs-dot">
                                    </div>
                                    <p class="pdf-text-white">اعـرض شـريحة التعريـف بالمركـز السـعودي لألعمـال
                                        االقتصاديـة، ووضـح
                                        للمشـاركين ماهيـة
                                        المركـز ورؤيتـه وأهميتـهلألعمـال االقتصاديـة، ووضـح للمشـاركين ماهيـة.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="container max-w-h bg-white-pdf my-2">
        <div class="p-pdf-bottom">
            <div class="px-6rem">
                <div class="d-flex">
                    <img class="pdf-page-logo" src="../../../../assets/new-logo/SCBCLOGO-COLOR.svg" alt="loading">
                    <div class="b-bottom"></div>
                </div>
                <h6 class="pdf-heading my-5">الفهرس</h6>
                <!-- parent start -->
                <div class="d-flex">
                    <div class="w-80rem">الوحدة الثالثة خدمات وزارة االستثمار</div>
                    <div class="w-20rem">4</div>
                </div>
                <div class="d-flex">
                    <div class="w-80rem">شكر وترحيب </div>
                    <div class="w-20rem">0</div>
                </div>
                <div class="d-flex">
                    <div class="w-80rem">جدول الرموز </div>
                    <div class="w-20rem">6</div>
                </div>
                <div class="d-flex">
                    <div class="w-80rem">إرشادات المدرب</div>
                    <div class="w-20rem">77</div>
                </div>
                <div class="d-flex">
                    <div class="w-80rem">إرشادات المشارك</div>
                    <div class="w-20rem">99</div>
                </div>
                <div class="d-flex">
                    <div class="w-80rem">المقدمة </div>
                    <div class="w-20rem">1</div>
                </div>
                <!-- parent end -->
                <!-- child start -->
                <div class="d-flex">
                    <div class="w-80rem-child">دليـل البرنامج</div>
                    <div class="w-20rem">57</div>
                </div>
                <div class="d-flex">
                    <div class="w-80rem-child">األدوات والوسائل المستخدمة </div>
                    <div class="w-20rem">2</div>
                </div>
                <div class="d-flex">
                    <div class="w-80rem-child">الخطة الزمنية</div>
                    <div class="w-20rem">56</div>
                </div>
                <!-- child child end -->
                <!-- parent start -->
                <div class="d-flex">
                    <div class="w-80rem">الوحدة الثالثة خدمات وزارة االستثمار</div>
                    <div class="w-20rem">4</div>
                </div>
                <div class="d-flex">
                    <div class="w-80rem">شكر وترحيب </div>
                    <div class="w-20rem">0</div>
                </div>
                <div class="d-flex">
                    <div class="w-80rem">جدول الرموز </div>
                    <div class="w-20rem">6</div>
                </div>
                <div class="d-flex">
                    <div class="w-80rem">إرشادات المدرب</div>
                    <div class="w-20rem">77</div>
                </div>
                <div class="d-flex">
                    <div class="w-80rem">إرشادات المشارك</div>
                    <div class="w-20rem">99</div>
                </div>
                <div class="d-flex">
                    <div class="w-80rem">المقدمة </div>
                    <div class="w-20rem">1</div>
                </div>
                <!-- parent end -->
                <!-- child start -->
                <div class="d-flex">
                    <div class="w-80rem-child">دليـل البرنامج</div>
                    <div class="w-20rem">57</div>
                </div>
                <div class="d-flex">
                    <div class="w-80rem-child">األدوات والوسائل المستخدمة </div>
                    <div class="w-20rem">2</div>
                </div>
                <div class="d-flex">
                    <div class="w-80rem-child">الخطة الزمنية</div>
                    <div class="w-20rem">56</div>
                </div>
                <!-- child child end -->

            </div>
        </div>
    </div>

    <div class="container max-w-h bg-white-pdf my-2">
        <div class="p-pdf-bottom">
            <div class="px-6rem">
                <div class="d-flex mbb-2rem">
                    <div class="b-bottom"></div>
                    <p class="pdf-text-desc">خدمات وزارة االسـتثمار</p>
                </div>
                <!-- parent start -->
                <div class="d-flex">
                    <div class="w-80rem">الوحدة الثالثة خدمات وزارة االستثمار</div>
                    <div class="w-20rem">4</div>
                </div>
                <div class="d-flex">
                    <div class="w-80rem">شكر وترحيب </div>
                    <div class="w-20rem">0</div>
                </div>
                <div class="d-flex">
                    <div class="w-80rem">جدول الرموز </div>
                    <div class="w-20rem">6</div>
                </div>
                <div class="d-flex">
                    <div class="w-80rem">إرشادات المدرب</div>
                    <div class="w-20rem">77</div>
                </div>
                <div class="d-flex">
                    <div class="w-80rem">إرشادات المشارك</div>
                    <div class="w-20rem">99</div>
                </div>
                <div class="d-flex">
                    <div class="w-80rem">المقدمة </div>
                    <div class="w-20rem">1</div>
                </div>
                <!-- parent end -->
                <!-- child start -->
                <div class="d-flex">
                    <div class="w-80rem-child">دليـل البرنامج</div>
                    <div class="w-20rem">57</div>
                </div>
                <div class="d-flex">
                    <div class="w-80rem-child">األدوات والوسائل المستخدمة </div>
                    <div class="w-20rem">2</div>
                </div>
                <div class="d-flex">
                    <div class="w-80rem-child">الخطة الزمنية</div>
                    <div class="w-20rem">56</div>
                </div>
                <!-- child child end -->
            </div>
        </div>
    </div>

    <div class="container max-w-h bg-white-pdf my-2">
        <div class="p-pdf-bottom">
            <div class="px-6rem">
                <div class="d-flex">
                    <img class="pdf-page-logo" src="../../../../assets/new-logo/SCBCLOGO-COLOR.svg" alt="loading">
                    <div class="b-bottom"></div>
                </div>
                <h6 class="pdf-heading my-5">الفهرس</h6>

                <div class="d-flex w-100">
                    <div class="d-flex w-100 mll-2">
                        <div class="w-40rem">ورشة عمل.</div>
                        <div class="w-10rem"><img class="pen-icon" src="../../../../assets/icons/SBC/penpaper.svg"
                                alt="loading">
                        </div>
                    </div>
                    <div class="d-flex w-100 mrr-2">
                        <div class="w-40rem">ورشة عمل.</div>
                        <div class="w-10rem"><img class="pen-icon" src="../../../../assets/icons/SBC/penpaper.svg"
                                alt="loading">
                        </div>
                    </div>
                </div>

                <div class="d-flex w-100">
                    <div class="d-flex w-100 mll-2">
                        <div class="w-40rem">ورشة عمل.</div>
                        <div class="w-10rem"><img class="pen-icon" src="../../../../assets/icons/SBC/penpaper.svg"
                                alt="loading">
                        </div>
                    </div>
                    <div class="d-flex w-100 mrr-2">
                        <div class="w-40rem">ورشة عمل.</div>
                        <div class="w-10rem"><img class="pen-icon" src="../../../../assets/icons/SBC/penpaper.svg"
                                alt="loading">
                        </div>
                    </div>
                </div>
                <div class="d-flex w-100">
                    <div class="d-flex w-100 mll-2">
                        <div class="w-40rem">ورشة عمل.</div>
                        <div class="w-10rem"><img class="pen-icon" src="../../../../assets/icons/SBC/penpaper.svg"
                                alt="loading">
                        </div>
                    </div>
                    <div class="d-flex w-100 mrr-2">
                        <div class="w-40rem">ورشة عمل.</div>
                        <div class="w-10rem"><img class="pen-icon" src="../../../../assets/icons/SBC/penpaper.svg"
                                alt="loading">
                        </div>
                    </div>
                </div>
                <div class="d-flex w-100">
                    <div class="d-flex w-100 mll-2">
                        <div class="w-40rem">ورشة عمل.</div>
                        <div class="w-10rem"><img class="pen-icon" src="../../../../assets/icons/SBC/penpaper.svg"
                                alt="loading">
                        </div>
                    </div>
                    <div class="d-flex w-100 mrr-2">
                        <div class="w-40rem">ورشة عمل.</div>
                        <div class="w-10rem"><img class="pen-icon" src="../../../../assets/icons/SBC/penpaper.svg"
                                alt="loading">
                        </div>
                    </div>
                </div>
                <div class="d-flex w-100">
                    <div class="d-flex w-100 mll-2">
                        <div class="w-40rem">ورشة عمل.</div>
                        <div class="w-10rem"><img class="pen-icon" src="../../../../assets/icons/SBC/penpaper.svg"
                                alt="loading">
                        </div>
                    </div>
                    <div class="d-flex w-100 mrr-2">
                        <div class="w-40rem">ورشة عمل.</div>
                        <div class="w-10rem"><img class="pen-icon" src="../../../../assets/icons/SBC/penpaper.svg"
                                alt="loading">
                        </div>
                    </div>
                </div>
                <div class="d-flex w-100">
                    <div class="d-flex w-100 mll-2">
                        <div class="w-40rem">ورشة عمل.</div>
                        <div class="w-10rem"><img class="pen-icon" src="../../../../assets/icons/SBC/penpaper.svg"
                                alt="loading">
                        </div>
                    </div>
                    <div class="d-flex w-100 mrr-2">
                        <div class="w-40rem">ورشة عمل.</div>
                        <div class="w-10rem"><img class="pen-icon" src="../../../../assets/icons/SBC/penpaper.svg"
                                alt="loading">
                        </div>
                    </div>
                </div>
                <div class="d-flex w-100">
                    <div class="d-flex w-100 mll-2">
                        <div class="w-40rem">ورشة عمل.</div>
                        <div class="w-10rem"><img class="pen-icon" src="../../../../assets/icons/SBC/penpaper.svg"
                                alt="loading">
                        </div>
                    </div>
                    <div class="d-flex w-100 mrr-2">
                        <div class="w-40rem">ورشة عمل.</div>
                        <div class="w-10rem"><img class="pen-icon" src="../../../../assets/icons/SBC/penpaper.svg"
                                alt="loading">
                        </div>
                    </div>
                </div>
                <div class="d-flex w-100">
                    <div class="d-flex w-100 mll-2">
                        <div class="w-40rem">ورشة عمل.</div>
                        <div class="w-10rem"><img class="pen-icon" src="../../../../assets/icons/SBC/penpaper.svg"
                                alt="loading">
                        </div>
                    </div>
                    <div class="d-flex w-100 mrr-2">
                        <div class="w-40rem">ورشة عمل.</div>
                        <div class="w-10rem"><img class="pen-icon" src="../../../../assets/icons/SBC/penpaper.svg"
                                alt="loading">
                        </div>
                    </div>
                </div>
                <div class="d-flex w-100">
                    <div class="d-flex w-100 mll-2">
                        <div class="w-40rem">ورشة عمل.</div>
                        <div class="w-10rem"><img class="pen-icon" src="../../../../assets/icons/SBC/penpaper.svg"
                                alt="loading">
                        </div>
                    </div>
                    <div class="d-flex w-100 mrr-2">
                        <div class="w-40rem">ورشة عمل.</div>
                        <div class="w-10rem"><img class="pen-icon" src="../../../../assets/icons/SBC/penpaper.svg"
                                alt="loading">
                        </div>
                    </div>
                </div>


            </div>
        </div>
    </div>

    <div class="container max-w-h bg-white-pdf my-2">
        <div class="p-pdf-bottom">
            <div class="px-6rem">
                <div class="d-flex">
                    <div class="b-bottom"></div>
                    <p class="pdf-text-desc">خدمات وزارة االسـتثمار</p>
                </div>
                <h6 class="pdf-heading my-5">إرشادات المدرب</h6>
                <h6 class="pdf-heading-sky-mini">عزيزي المدرب: </h6>
                <h6 class="pdf-heading-sky">قبل الجلسة التدريبية بيومين على األقل:</h6>
                <div class="d-flex align-items-baseline mrr-4">
                    <div>
                        <div class="list-dot"></div>
                    </div>
                    <p class="pdf-text"> اطلـع علـى اإلرشـادات والتوجيهـات فـي حقيبـة المـدرب، فهـي ستسـاهم بـإذن اللـه
                        فـي توضيـح
                        مـا</p>
                </div>
                <div class="d-flex align-items-baseline mrr-4">
                    <div>
                        <div class="list-dot"></div>
                    </div>
                    <p class="pdf-text">اإلرشـادات والتوجيهـات وضِ عـت لمسـاعدتك فـي تنفيـذ األنشـطة التدريبيـة وفقً ـا
                        ألفضـل
                        سـيناريو
                        وبمـا يضمـن تحقيـق أهـداف النشـاط، ومـع ذلـك يمكنـك تغييـر أسـلوب تنفيـذ النشـاط بشـرط ضمـان
                        تحقـق أهـداف النشـاط باألسـلوب الـذي سـتتَّ بعه.</p>
                </div>
                <div class="d-flex align-items-baseline mrr-4">
                    <div>
                        <div class="list-dot"></div>
                    </div>
                    <p class="pdf-text">احرص على قراءة الحقيبة التدريبية قبل التدريب بوقت كافٍ .</p>
                </div>
                <div class="d-flex align-items-baseline mrr-4">
                    <div>
                        <div class="list-dot"></div>
                    </div>
                    <p class="pdf-text">تحقق من توافر المعينات التدريبية التي سيتم استخدامها في األنشطة التدريبية.</p>
                </div>
                <div class="d-flex align-items-baseline mrr-4">
                    <div>
                        <div class="list-dot"></div>
                    </div>
                    <p class="pdf-text">راجـع أسـاليب تنفيـذ األنشـطة وتحقـق مـن إمكانيـة تطبيـق هـذه األسـاليب فـي
                        البيئـة
                        التدريبيـة التـي
                        سـتنفذ بهـا التدريب.
                    </p>
                </div>
                <div class="d-flex align-items-baseline mrr-4">
                    <div>
                        <div class="list-dot"></div>
                    </div>
                    <p class="pdf-text"> ً راجع شرائح العرض التقديمي وخطط لعملية التدريب جيدا</p>
                </div>
                <div class="d-flex align-items-baseline mrr-4">
                    <div>
                        <div class="list-dot"></div>
                    </div>
                    <p class="pdf-text">ضـع خطـط وطرائـق أخـرى لتنفيـذ األنشـطة التدريبيـة إن كانـت األسـاليب التدريبيـة
                        غيـر
                        مناسـبة مـع
                        المشـاركين والبيئـة.</p>
                </div>
                <h6 class="pdf-heading-sky">قبل الجلسة التدريبية بيوم: </h6>
                <div class="d-flex align-items-baseline mrr-4">
                    <div>
                        <div class="list-dot"></div>
                    </div>
                    <p class="pdf-text">تحقق من توافر المعينات التدريبية بعدد المشاركين قبل الجلسة التدريبية.</p>
                </div>
                <div class="d-flex align-items-baseline mrr-4">
                    <div>
                        <div class="list-dot"></div>
                    </div>
                    <p class="pdf-text">أعد مراجعة اليوم التدريبي األول، وأعد نفسك جيدا.</p>
                </div>
                <h6 class="pdf-heading-sky">قبل الجلسة التدريبية بساعة:</h6>
                <div class="d-flex align-items-baseline mrr-4">
                    <div>
                        <div class="list-dot"></div>
                    </div>
                    <p class="pdf-text">جهز نفسك قبل بدء الدورة بوقت كافٍ .</p>
                </div>
                <div class="d-flex align-items-baseline mrr-4">
                    <div>
                        <div class="list-dot"></div>
                    </div>
                    <p class="pdf-text">احضر باكرا وحاول التحقق من القاعة والتعرف على مخارج الطوارئ وموقع الصالة
                        والضيافة. </p>
                </div>
                <div class="d-flex align-items-baseline mrr-4">
                    <div>
                        <div class="list-dot"></div>
                    </div>
                    <p class="pdf-text">راجع مع منسق التدريب المعينات التدريبية وتحقق من توافرها كاملة. </p>
                </div>
                <div class="d-flex align-items-baseline mrr-4">
                    <div>
                        <div class="list-dot"></div>
                    </div>
                    <p class="pdf-text"> استقبل المشاركين ورحب بهم. </p>
                </div>
                <h6 class="pdf-heading-sky">قبل الجلسة التدريبية بيومين على األقل:</h6>
                <div class="d-flex align-items-baseline mrr-4">
                    <div>
                        <div class="list-dot"></div>
                    </div>
                    <p class="pdf-text"> اطلـع علـى اإلرشـادات والتوجيهـات فـي حقيبـة المـدرب، فهـي ستسـاهم بـإذن اللـه
                        فـي توضيـح
                        مـا</p>
                </div>
                <div class="d-flex align-items-baseline mrr-4">
                    <div>
                        <div class="list-dot"></div>
                    </div>
                    <p class="pdf-text">اإلرشـادات والتوجيهـات وضِ عـت لمسـاعدتك فـي تنفيـذ األنشـطة التدريبيـة وفقً ـا
                        ألفضـل
                        سـيناريو
                        وبمـا يضمـن تحقيـق أهـداف النشـاط، ومـع ذلـك يمكنـك تغييـر أسـلوب تنفيـذ النشـاط بشـرط ضمـان
                        تحقـق أهـداف النشـاط باألسـلوب الـذي سـتتَّ بعه.</p>
                </div>
                <div class="d-flex align-items-baseline mrr-4">
                    <div>
                        <div class="list-dot"></div>
                    </div>
                    <p class="pdf-text">احرص على قراءة الحقيبة التدريبية قبل التدريب بوقت كافٍ .</p>
                </div>
                <div class="d-flex align-items-baseline mrr-4">
                    <div>
                        <div class="list-dot"></div>
                    </div>
                    <p class="pdf-text">تحقق من توافر المعينات التدريبية التي سيتم استخدامها في األنشطة التدريبية.</p>
                </div>
                <div class="d-flex align-items-baseline mrr-4">
                    <div>
                        <div class="list-dot"></div>
                    </div>
                    <p class="pdf-text">راجـع أسـاليب تنفيـذ األنشـطة وتحقـق مـن إمكانيـة تطبيـق هـذه األسـاليب فـي
                        البيئـة
                        التدريبيـة التـي
                        سـتنفذ بهـا التدريب.
                    </p>
                </div>
                <div class="d-flex align-items-baseline mrr-4">
                    <div>
                        <div class="list-dot"></div>
                    </div>
                    <p class="pdf-text"> ً راجع شرائح العرض التقديمي وخطط لعملية التدريب جيدا</p>
                </div>
                <div class="d-flex align-items-baseline mrr-4">
                    <div>
                        <div class="list-dot"></div>
                    </div>
                    <p class="pdf-text">ضـع خطـط وطرائـق أخـرى لتنفيـذ األنشـطة التدريبيـة إن كانـت األسـاليب التدريبيـة
                        غيـر
                        مناسـبة مـع
                        المشـاركين والبيئـة.</p>
                </div>
            </div>
        </div>
    </div>

    <div class="container max-w-h bg-white-pdf my-2">
        <div class="p-pdf-bottom">
            <div class="px-6rem">
                <div class="d-flex">
                    <img class="pdf-page-logo" src="../../../../assets/new-logo/SCBCLOGO-COLOR.svg" alt="loading">
                    <div class="b-bottom"></div>
                </div>
                <div class="d-flex flex-column w-100 mtt-3rem">
                    <div class="d-flex pen-box">
                        <img class="pen-icon" src="../../../../assets/icons/SBC/penpaper.svg" alt="loading">
                        <h6 class="pdf-heading pen-icon-bar">إرشادات المدرب</h6>
                    </div>
                    <div class="pos-rel-pdf">
                        <div class="pen-pos-abs">
                            <div class="pen-blue-box">
                                <div class="pdf-pos-rel">
                                    <div class="pdf-pos-abs-dot">
                                    </div>
                                    <p class="pdf-text-white">اعـرض شـريحة التعريـف بالمركـز السـعودي لألعمـال
                                        االقتصاديـة، ووضـح
                                        للمشـاركين ماهيـة
                                        المركـز ورؤيتـه وأهميتـه.</p>
                                </div>
                                <div class="pdf-pos-rel">
                                    <div class="pdf-pos-abs-dot">
                                    </div>
                                    <p class="pdf-text-white">اعـرض شـريحة التعريـف بالمركـز السـعودي لألعمـال
                                        االقتصاديـة، ووضـح
                                        للمشـاركين ماهيـة
                                        المركـز ورؤيتـه وأهميتـهلألعمـال االقتصاديـة، ووضـح للمشـاركين ماهيـة.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="container max-w-h bg-white-pdf my-2">
        <div class="p-pdf-bottom">
            <div class="px-6rem">
                <div class="d-flex">
                    <div class="b-bottom"></div>
                    <p class="pdf-text-desc">خدمات وزارة االسـتثمار</p>
                </div>
                <h6 class="pdf-heading my-5">إرشادات المدرب</h6>
                <h6 class="pdf-heading-sky-mini">عزيزي المدرب: </h6>
                <h6 class="pdf-heading-sky">قبل الجلسة التدريبية بيومين على األقل:</h6>
                <div class="d-flex align-items-baseline mrr-4">
                    <div>
                        <div class="list-dot"></div>
                    </div>
                    <p class="pdf-text"> اطلـع علـى اإلرشـادات والتوجيهـات فـي حقيبـة المـدرب، فهـي ستسـاهم بـإذن اللـه
                        فـي توضيـح
                        مـا</p>
                </div>
                <div class="d-flex align-items-baseline mrr-4">
                    <div>
                        <div class="list-dot"></div>
                    </div>
                    <p class="pdf-text">اإلرشـادات والتوجيهـات وضِ عـت لمسـاعدتك فـي تنفيـذ األنشـطة التدريبيـة وفقً ـا
                        ألفضـل
                        سـيناريو
                        وبمـا يضمـن تحقيـق أهـداف النشـاط، ومـع ذلـك يمكنـك تغييـر أسـلوب تنفيـذ النشـاط بشـرط ضمـان
                        تحقـق أهـداف النشـاط باألسـلوب الـذي سـتتَّ بعه.</p>
                </div>
                <div class="d-flex align-items-baseline mrr-4">
                    <div>
                        <div class="list-dot"></div>
                    </div>
                    <p class="pdf-text">احرص على قراءة الحقيبة التدريبية قبل التدريب بوقت كافٍ .</p>
                </div>
                <div class="d-flex align-items-baseline mrr-4">
                    <div>
                        <div class="list-dot"></div>
                    </div>
                    <p class="pdf-text">تحقق من توافر المعينات التدريبية التي سيتم استخدامها في األنشطة التدريبية.</p>
                </div>
                <div class="d-flex align-items-baseline mrr-4">
                    <div>
                        <div class="list-dot"></div>
                    </div>
                    <p class="pdf-text">راجـع أسـاليب تنفيـذ األنشـطة وتحقـق مـن إمكانيـة تطبيـق هـذه األسـاليب فـي
                        البيئـة
                        التدريبيـة التـي
                        سـتنفذ بهـا التدريب.
                    </p>
                </div>
                <div class="d-flex align-items-baseline mrr-4">
                    <div>
                        <div class="list-dot"></div>
                    </div>
                    <p class="pdf-text"> ً راجع شرائح العرض التقديمي وخطط لعملية التدريب جيدا</p>
                </div>
                <div class="d-flex align-items-baseline mrr-4">
                    <div>
                        <div class="list-dot"></div>
                    </div>
                    <p class="pdf-text">ضـع خطـط وطرائـق أخـرى لتنفيـذ األنشـطة التدريبيـة إن كانـت األسـاليب التدريبيـة
                        غيـر
                        مناسـبة مـع
                        المشـاركين والبيئـة.</p>
                </div>
                <h6 class="pdf-heading-sky">قبل الجلسة التدريبية بيوم: </h6>
                <div class="d-flex align-items-baseline mrr-4">
                    <div>
                        <div class="list-dot"></div>
                    </div>
                    <p class="pdf-text">تحقق من توافر المعينات التدريبية بعدد المشاركين قبل الجلسة التدريبية.</p>
                </div>
                <div class="d-flex align-items-baseline mrr-4">
                    <div>
                        <div class="list-dot"></div>
                    </div>
                    <p class="pdf-text">أعد مراجعة اليوم التدريبي األول، وأعد نفسك جيدا.</p>
                </div>
                <h6 class="pdf-heading-sky">قبل الجلسة التدريبية بساعة:</h6>
                <div class="d-flex align-items-baseline mrr-4">
                    <div>
                        <div class="list-dot"></div>
                    </div>
                    <p class="pdf-text">جهز نفسك قبل بدء الدورة بوقت كافٍ .</p>
                </div>
                <div class="d-flex align-items-baseline mrr-4">
                    <div>
                        <div class="list-dot"></div>
                    </div>
                    <p class="pdf-text">احضر باكرا وحاول التحقق من القاعة والتعرف على مخارج الطوارئ وموقع الصالة
                        والضيافة. </p>
                </div>
                <div class="d-flex align-items-baseline mrr-4">
                    <div>
                        <div class="list-dot"></div>
                    </div>
                    <p class="pdf-text">راجع مع منسق التدريب المعينات التدريبية وتحقق من توافرها كاملة. </p>
                </div>
                <div class="d-flex flex-column w-100 mtt-3rem">
                    <div class="d-flex pen-box">
                        <img class="pen-icon" src="../../../../assets/icons/SBC/penpaper.svg" alt="loading">
                        <h6 class="pdf-heading pen-icon-bar">إرشادات المدرب</h6>
                    </div>
                    <div class="pos-rel-pdf">
                        <div class="pen-pos-abs">
                            <div class="pen-blue-box">
                                <div class="pdf-pos-rel">
                                    <div class="pdf-pos-abs-dot">
                                    </div>
                                    <p class="pdf-text-white">اعـرض شـريحة التعريـف بالمركـز السـعودي لألعمـال
                                        االقتصاديـة، ووضـح
                                        للمشـاركين ماهيـة
                                        المركـز ورؤيتـه وأهميتـه.</p>
                                </div>
                                <div class="pdf-pos-rel">
                                    <div class="pdf-pos-abs-dot">
                                    </div>
                                    <p class="pdf-text-white">اعـرض شـريحة التعريـف بالمركـز السـعودي لألعمـال
                                        االقتصاديـة، ووضـح
                                        للمشـاركين ماهيـة
                                        المركـز ورؤيتـه وأهميتـهلألعمـال االقتصاديـة، ووضـح للمشـاركين ماهيـة.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="container max-w-h bg-white-pdf my-2">
        <div class="p-pdf-bottom">
            <div class="px-6rem">
                <div class="d-flex">
                    <div class="b-bottom"></div>
                    <p class="pdf-text-desc">خدمات وزارة االسـتثمار</p>
                </div>
                <div class="d-flex justify-content-center">
                    <h6 class="pdf-heading my-5">شكر وترحيب</h6>
                </div>
                <p class="pdf-text mb-3rem">يتقـدم المركـز السـعودي لألعمـال االقتصاديـة بالشـكر والترحيـب بالمشـاركين
                    فـي
                    البرنامـج التدريبـي، كمـا
                    َّ يتمنـى لهـم االسـتفادة الفاعلـة منـه، آمليـن أن ينعكـس أثـر هـذا التدريـب علـى جـودة الخدمـات
                    المقدمـة مـن
                    َقِ ب ً ـل المركـز السـعودي لألعمـال االقتصاديـة، وأن يشـكل دور ً ا حقيقيـا فـي تطويـر رؤيتـه،
                    ورسـالته،
                    وأهدافـه،
                    وأن يقـدم خدمـة شـاملة للمسـتثمرين تسـاهم فـي تحقيـق رؤيـة المملكـة 2030م بعـون اللـه تعالـى.</p>
                <div class="my-5 py-5">
                    <h1 style="color: lightgrey;" class="my-5 py-5 text-center">
                        DIAGRAM DESIGN
                    </h1>
                </div>
                <p class="pdf-text mb-3rem">يتقـدم المركـز السـعودي لألعمـال االقتصاديـة بالشـكر والترحيـب بالمشـاركين
                    فـي
                    البرنامـج التدريبـي، كمـا
                    َّ يتمنـى لهـم االسـتفادة الفاعلـة منـه، آمليـن أن ينعكـس أثـر هـذا التدريـب علـى جـودة الخدمـات
                    المقدمـة مـن
                    َقِ ب ً ـل المركـز السـعودي لألعمـال االقتصاديـة، وأن يشـكل دور ً ا حقيقيـا فـي تطويـر رؤيتـه،
                    ورسـالته،
                    وأهدافـه،
                    وأن يقـدم خدمـة شـاملة للمسـتثمرين تسـاهم فـي تحقيـق رؤيـة المملكـة 2030م بعـون اللـه تعالـى.</p>
                <div class="d-flex justify-content-end">
                    <p class="pdf-black">فريق العمل</p>
                </div>

            </div>
        </div>
    </div>

    <div class="container max-w-h bg-white-pdf my-2">
        <div class="p-pdf-bottom">
            <div class="px-6rem">
                <div class="d-flex">
                    <div class="b-bottom"></div>
                    <p class="pdf-text-desc">خدمات وزارة االسـتثمار</p>
                </div>
                <h6 class="pdf-heading mtt-3rem">إرشادات المدرب</h6>
                <h6 class="pdf-heading-sky-mini my-3">عزيزي المدرب: </h6>
                <!-- table start -->
                <div class="mask">
                    <div>
                        <table>
                            <thead>
                                <tr>
                                    <th>م</th>
                                    <th>المستلزمات </th>
                                    <th>العدد</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>1</td>
                                    <td>شاشة عرض.</td>
                                    <td>9</td>
                                </tr>
                                <tr>
                                    <td>2</td>
                                    <td>وحة عرض Flipchart.</td>
                                    <td>4</td>
                                </tr>
                                <tr>
                                    <td>3</td>
                                    <td>أقالم تخطيط ملونة.</td>
                                    <td>7</td>
                                </tr>
                                <tr>
                                    <td>1</td>
                                    <td>شاشة عرض.</td>
                                    <td>9</td>
                                </tr>
                                <tr>
                                    <td>2</td>
                                    <td>وحة عرض Flipchart.</td>
                                    <td>4</td>
                                </tr>
                                <tr>
                                    <td>3</td>
                                    <td>أقالم تخطيط ملونة.</td>
                                    <td>7</td>
                                </tr>
                                <tr>
                                    <td>1</td>
                                    <td>شاشة عرض.</td>
                                    <td>9</td>
                                </tr>
                                <tr>
                                    <td>2</td>
                                    <td>وحة عرض Flipchart.</td>
                                    <td>4</td>
                                </tr>
                                <tr>
                                    <td>3</td>
                                    <td>أقالم تخطيط ملونة.</td>
                                    <td>7</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <!-- table end -->
                <h6 class="pdf-heading-sky-mini my-3">عزيزي المدرب: </h6>
                <!-- table start -->
                <div class="mask">
                    <div>
                        <table>
                            <thead>
                                <tr>
                                    <th>اليوم
                                        التدريبي
                                    </th>
                                    <th>النشاط</th>
                                    <th>العدد</th>
                                    <th>وصف األداة</th>
                                    <th>الحجم</th>
                                    <th>اإلجمالي</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>1</td>
                                    <td>فئات االستثمار في المملكة</td>
                                    <td>4</td>
                                    <td>بطاقة</td>
                                    <td>A5</td>
                                    <td>مجموعة واحدة. </td>
                                </tr>
                                <tr>
                                    <td>1</td>
                                    <td>فئات االستثمار في المملكة</td>
                                    <td>4</td>
                                    <td>بطاقة</td>
                                    <td>0 × 15 سم</td>
                                    <td>مجموعة واحدة. </td>
                                </tr>
                                <tr>
                                    <td>1</td>
                                    <td>فئات االستثمار في المملكة</td>
                                    <td>4</td>
                                    <td>بطاقة</td>
                                    <td>A5</td>
                                    <td>مجموعة واحدة. </td>
                                </tr>
                                <tr>
                                    <td>1</td>
                                    <td>فئات االستثمار في المملكة</td>
                                    <td>4</td>
                                    <td>بطاقة</td>
                                    <td>0 × 15 سم</td>
                                    <td>مجموعة واحدة. </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <!-- table end -->
                <div class="d-flex flex-column w-100 mtt-3rem">
                    <div class="d-flex pen-box">
                        <img class="pen-icon" src="../../../../assets/icons/SBC/penpaper.svg" alt="loading">
                        <h6 class="pdf-heading pen-icon-bar">إرشادات المدرب</h6>
                    </div>
                    <div class="pos-rel-pdf">
                        <div class="pen-pos-abs">
                            <div class="pen-blue-box">
                                <div class="pdf-pos-rel">
                                    <div class="pdf-pos-abs-dot">
                                    </div>
                                    <p class="pdf-text-white">اعـرض شـريحة التعريـف بالمركـز السـعودي لألعمـال
                                        االقتصاديـة، ووضـح
                                        للمشـاركين ماهيـة
                                        المركـز ورؤيتـه وأهميتـه.</p>
                                </div>
                                <div class="pdf-pos-rel">
                                    <div class="pdf-pos-abs-dot">
                                    </div>
                                    <p class="pdf-text-white">اعـرض شـريحة التعريـف بالمركـز السـعودي لألعمـال
                                        االقتصاديـة، ووضـح
                                        للمشـاركين ماهيـة
                                        المركـز ورؤيتـه وأهميتـهلألعمـال االقتصاديـة، ووضـح للمشـاركين ماهيـة.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="container max-w-h bg-white-pdf my-2">
        <div class="p-pdf-bottom">
            <div class="px-6rem">
                <div class="d-flex">
                    <div class="b-bottom"></div>
                    <p class="pdf-text-desc">خدمات وزارة االسـتثمار</p>
                </div>
                <h6 class="pdf-heading mtt-3rem">الخطة الزمنية</h6>
                <!-- table start -->
                <div class="mask">
                    <div>
                        <table>
                            <thead>
                                <tr>
                                    <th>اليوم
                                        التدريبي</th>
                                    <th>رقم
                                        الوحدة</th>
                                    <th>عنوان الوحدة
                                        التدريبية
                                    </th>
                                    <th>الجلسةالتدريبية</th>
                                    <th>موضوعات الجلسة</th>
                                    <th>الزمن بالدقيقة</th>
                                </tr>
                            </thead>
                            <tbody>
                                <!-- 1st <tr> start -->
                                <tr>
                                    <td rowspan="11">األول</td>
                                    <td rowspan="4">األولى</td>
                                    <td rowspan="4">التعريفبوزارةاالستثمار</td>
                                    <td rowspan="4">األولى</td>
                                    <td>االفتتاح.</td>
                                    <td>10</td>
                                </tr>
                                <tr>
                                    <td>التقييم القبلي.</td>
                                    <td>15</td>
                                </tr>
                                <tr>
                                    <td>نبذة عن وزارة االستثمار</td>
                                    <td>25</td>
                                </tr>
                                <tr>
                                    <td>صالحيات وزارة االستثمار</td>
                                    <td>30</td>
                                </tr>
                                <tr>
                                    <td colspan="4" style="background-color: #082564; color: white;">tab 4</td>
                                    <td style="background-color: #082564; color: white;">tab 6</td>
                                </tr>
                                <tr>
                                    <td rowspan="2">األولى</td>
                                    <td rowspan="2">التعريفبوزارةاالستثمار</td>
                                    <td rowspan="2">الثانية</td>
                                    <td>مراحل تطور االستثمار في المملكة.</td>
                                    <td>25</td>
                                </tr>
                                <tr>
                                    <td>الخدمات اإللكترونية.</td>
                                    <td>30</td>
                                </tr>
                                <tr>
                                    <td colspan="4" style="background-color: #082564; color: white;">استراحة</td>
                                    <td style="background-color: #082564; color: white;">15</td>
                                </tr>
                                <tr>
                                    <td rowspan="3">الثانية</td>
                                    <td rowspan="3">التعريفبوزارةاالستثمار</td>
                                    <td rowspan="3">الثانية </td>
                                    <td>مراحل تطور االستثمار في المملكة.</td>
                                    <td>20</td>
                                </tr>
                                <tr>
                                    <td>الخدمات اإللكترونية.</td>
                                    <td>25</td>
                                </tr>
                                <tr>
                                    <td></td>
                                    <td>30</td>
                                </tr>
                                <tr>
                                    <td colspan="6" style="background-color: #082564; padding: 15px 0px;"></td>
                                </tr>
                                <!-- 1st <tr> end -->
                                <!-- 2nd <tr> start -->
                                <tr>
                                    <td rowspan="11">الثاني</td>
                                    <td rowspan="2">الثانية</td>
                                    <td rowspan="2">التعريفبوزارةاالستثمار</td>
                                    <td rowspan="3">األولى</td>
                                    <td>رحلة المستثمر. </td>
                                    <td>25</td>
                                </tr>
                                <tr>
                                    <td>تصنيف خدمات وزارة االستثمار.</td>
                                    <td>25</td>
                                </tr>
                                <tr>
                                    <td>الثالثة</td>
                                    <td>التعريفبوزارةاالستثمار</td>
                                    <td>أبرز خدمات إصدار التراخيص</td>
                                    <td>35</td>
                                </tr>
                                <tr>
                                    <td colspan="4" style="background-color: #082564; color: white;">استراحة</td>
                                    <td style="background-color: #082564; color: white;">15</td>
                                </tr>
                                <tr>
                                    <td rowspan="2">الثالثة</td>
                                    <td rowspan="2">التعريفبوزارةاالستثمار</td>
                                    <td rowspan="2">الثانية</td>
                                    <td>أبرز خدمات خدمة تعديل التراخيص.</td>
                                    <td>40</td>
                                </tr>
                                <tr>
                                    <td>خدمة تجديد التراخيص.</td>
                                    <td>15</td>
                                </tr>
                                <tr>
                                    <td colspan="4" style="background-color: #082564; color: white;">استراحة</td>
                                    <td style="background-color: #082564; color: white;">15</td>
                                </tr>
                                <tr>
                                    <td rowspan="4">الثالثة</td>
                                    <td rowspan="4">التعريفبوزارةاالستثمار</td>
                                    <td rowspan="4">الثالثة</td>
                                    <td>أبرز خدمات وزارة االستثمار الخاصة
                                        بمركز عالقات المستثمرين.</td>
                                    <td>40</td>
                                </tr>
                                <tr>
                                    <td>التقييم البعدي </td>
                                    <td>15</td>
                                </tr>
                                <tr>
                                    <td>تقييم البرنامج التدريبي</td>
                                    <td>10</td>
                                </tr>
                                <tr>
                                    <td>الختام</td>
                                    <td>5</td>
                                </tr>
                                <tr>
                                    <td colspan="5" style="background-color: #082564; color: white;">مجموع الزمن</td>
                                    <td style="background-color: #082564; color: white;">480دقيقة</td>
                                </tr>


                                <!-- 2nd <tr> end -->
                            </tbody>
                        </table>
                    </div>
                </div>
                <!-- table end -->
            </div>
        </div>
    </div>

    <div class="container max-w-h bg-white-pdf my-2 pos-rel-pdf">
        <div class="pos-abs-grey-box"></div>
        <div class="p-pdf-bottom">
            <div class="px-6rem">
                <div class="d-flex">
                    <div class="b-bottom"></div>
                    <p class="pdf-text-desc">خدمات وزارة االسـتثمار</p>
                </div>
                <h6 class="pdf-heading mtt-3rem z-index-1">إرشادات المدرب</h6>
                <!-- table start -->
                <div class="mask z-index-1">
                    <div>
                        <table>
                            <thead>
                                <tr>
                                    <th>م</th>
                                    <th>المستلزمات </th>
                                    <th>العدد</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td rowspan="4">1</td>
                                    <td>شاشة عرض.</td>
                                    <td>9</td>
                                </tr>
                                <tr>
                                    <td>شاشة عرض.</td>
                                    <td>9</td>
                                </tr>
                                <tr>
                                    <td>شاشة عرض.</td>
                                    <td>9</td>
                                </tr>
                                <tr>
                                    <td>شاشة عرض.</td>
                                    <td>9</td>
                                </tr>
                                <tr>
                                    <td colspan="2" style="background-color: #082564; color: white;">استراحة</td>
                                    <td style="background-color: #082564; color: white;">15</td>
                                </tr>
                                <tr>
                                    <td rowspan="2">1</td>
                                    <td>شاشة عرض.</td>
                                    <td>9</td>
                                </tr>
                                <tr>
                                    <td>شاشة عرض.</td>
                                    <td>9</td>
                                </tr>
                                <tr>
                                    <td colspan="2" style="background-color: #082564; color: white;">استراحة</td>
                                    <td style="background-color: #082564; color: white;">15</td>
                                </tr>
                                <tr>
                                    <td rowspan="3">1</td>
                                    <td>شاشة عرض.</td>
                                    <td>9</td>
                                </tr>
                                <tr>
                                    <td>شاشة عرض.</td>
                                    <td>9</td>
                                </tr>
                                <tr>
                                    <td>شاشة عرض.</td>
                                    <td>9</td>
                                </tr>
                                <tr>
                                    <td colspan="2" style="background-color: #082564; color: white;">استراحة</td>
                                    <td style="background-color: #082564; color: white;">15</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <!-- table end -->
            </div>
        </div>
    </div>

    <div class="container max-w-h banner my-2">
        <div class="bg-banner">
            <div class="d-flex flex-column">
                <img class="pdf-logo" src="../../../../assets/new-logo/SCBCLOGO-COLOR.svg" alt="loading">
                <div class="bg-gradiant-ui">
                    <div class="sticky-pos-rel">
                        <div class="sticky-sky-bar"></div>
                        <div class="sticky-blu-box">
                            <h2 class="sticky-text">الوحدة األولى</h2>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="container max-w-h banner my-2">
        <div class="bg-banner">
            <div class="d-flex flex-column">
                <img class="pdf-logo" src="../../../../assets/new-logo/SCBCLOGO-COLOR.svg" alt="loading">
                <div class="bg-gradiant-ui">
                    <div class="d-flex justify-content-end mtt-mll-auto">
                        <h2 class="sticky-text">التعريف بوزارة االستثمار</h2>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="container max-w-h banner my-2">
        <div class="bg-banner">
            <div class="d-flex flex-column">
                <img class="pdf-logo" src="../../../../assets/new-logo/SCBCLOGO-COLOR.svg" alt="loading">

            </div>
        </div>
    </div>

    <div class="container max-w-h bg-white-pdf my-2">
        <div class="p-pdf-bottom">
            <div class="px-6rem">
                <div class="d-flex">
                    <img class="pdf-page-logo" src="../../../../assets/new-logo/SCBCLOGO-COLOR.svg" alt="loading">
                    <div class="b-bottom"></div>
                </div>
                <div class="table-border-left mtt-3rem">إرشادات المدرب</div>
                <!-- table start -->
                <div class="table-border-right">
                    <div class="mask">
                        <div>
                            <table>
                                <thead>
                                    <tr>
                                        <th>م</th>
                                        <th>المستلزمات </th>
                                        <th>العدد</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td rowspan="4">1</td>
                                        <td>شاشة عرض.</td>
                                        <td>9</td>
                                    </tr>
                                    <tr>
                                        <td>شاشة عرض.</td>
                                        <td>9</td>
                                    </tr>
                                    <tr>
                                        <td>شاشة عرض.</td>
                                        <td>9</td>
                                    </tr>
                                    <tr>
                                        <td>شاشة عرض.</td>
                                        <td>9</td>
                                    </tr>
                                    <tr>
                                        <td colspan="2" style="background-color: #082564; color: white;">استراحة</td>
                                        <td style="background-color: #082564; color: white;">15</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
                <!-- table end -->
                <div class="d-flex icon-adjustment">
                    <img class="pen-icon" src="../../../../assets/icons/SBC/inkpaper.svg" alt="loading">
                    <h6 class="pdf-heading">هداف الجلسة</h6>
                </div>
                <h6 class="pdf-heading-sky-mini font-500">مع نهاية هذه الجلسة بإذن الله؛ سيكون المتدرب قادرا على أن:
                </h6>
                <div class="d-flex align-items-baseline mrr-4">
                    <div>
                        <div class="list-dot"></div>
                    </div>
                    <p class="pdf-text"> اطلـع علـى اإلرشـادات والتوجيهـات فـي حقيبـة المـدرب، فهـي ستسـاهم بـإذن اللـه
                        فـي توضيـح
                        مـا</p>
                </div>
                <div class="d-flex align-items-baseline mrr-4">
                    <div>
                        <div class="list-dot"></div>
                    </div>
                    <p class="pdf-text">اإلرشـادات والتوجيهـات وضِ عـت لمسـاعدتك فـي تنفيـذ األنشـطة التدريبيـة وفقً ـا
                        ألفضـل
                        سـيناريو
                        وبمـا يضمـن تحقيـق أهـداف النشـاط، ومـع ذلـك يمكنـك تغييـر أسـلوب تنفيـذ النشـاط بشـرط ضمـان
                        تحقـق أهـداف النشـاط باألسـلوب الـذي سـتتَّ بعه.</p>
                </div>
            </div>
        </div>
    </div>

    <div class="container max-w-h bg-white-pdf my-2">
        <div class="p-pdf-bottom">
            <div class="px-6rem">
                <div class="d-flex">
                    <div class="b-bottom"></div>
                    <p class="pdf-text-desc">خدمات وزارة االسـتثمار</p>
                </div>
                <div class="d-flex my-4">
                    <img class="pen-icon" src="../../../../assets/icons/SBC/inkpaper.svg" alt="loading">
                    <h6 class="pdf-heading-bg">مالحظات</h6>
                </div>
                <div class="d-flex flex-column">
                    <div class="papper-dotts"></div>
                    <div class="papper-dotts"></div>
                    <div class="papper-dotts"></div>
                    <div class="papper-dotts"></div>
                    <div class="papper-dotts"></div>
                    <div class="papper-dotts"></div>
                    <div class="papper-dotts"></div>
                    <div class="papper-dotts"></div>
                    <div class="papper-dotts"></div>
                    <div class="papper-dotts"></div>
                    <div class="papper-dotts"></div>
                    <div class="papper-dotts"></div>
                    <div class="papper-dotts"></div>
                    <div class="papper-dotts"></div>
                    <div class="papper-dotts"></div>
                    <div class="papper-dotts"></div>
                    <div class="papper-dotts"></div>
                    <div class="papper-dotts"></div>
                    <div class="papper-dotts"></div>
                    <div class="papper-dotts"></div>
                    <div class="papper-dotts"></div>
                </div>
            </div>
        </div>
    </div>

    <div class="container max-w-h bg-white-pdf my-2">
        <div class="p-pdf-bottom">
            <div class="px-6rem">
                <div class="d-flex">
                    <img class="pdf-page-logo" src="../../../../assets/new-logo/SCBCLOGO-COLOR.svg" alt="loading">
                    <div class="b-bottom"></div>
                </div>
                <div class="row mtt-3rem">
                    <div class="col-md-6 col-6">
                        <div class="d-flex">
                            <img class="pen-icon" src="../../../../assets/icons/SBC/penpaper.svg" alt="loading">
                            <h6 class="pdf-heading-bg">مالحظات</h6>
                        </div>
                    </div>
                    <div class="col-md-6 col-6">
                        <div class="d-flex justify-content-end align-items-baseline">
                            <img class="timer-stand-img" src="../../../../assets/icons/SBC/clock.svg" alt="loading">
                            <div class="timer-stand pos-rel-pdf">
                                <div class="timer-dot"></div>
                            </div>
                            <h6 class="timer-text">5 دقيقة</h6>
                        </div>
                    </div>
                </div>
                <h6 class="pdf-heading-sky-mini font-500 my-2">مع نهاية هذه الجلسة بإذن الله؛ سيكون المتدرب قادرا على
                    أن:</h6>
                <div class="d-flex justify-content-center align-items-center">
                    <img class="qr-code"
                        src="https://media.istockphoto.com/id/828088276/vector/qr-code-illustration.jpg?s=612x612&w=0&k=20&c=FnA7agr57XpFi081ZT5sEmxhLytMBlK4vzdQxt8A70M="
                        alt="loading">
                </div>
                <div class="d-flex flex-column w-100 mtt-3rem">
                    <div class="d-flex pen-box">
                        <img class="pen-icon" src="../../../../assets/icons/SBC/penpaper.svg" alt="loading">
                        <h6 class="pdf-heading pen-icon-bar">إرشادات المدرب</h6>
                    </div>
                    <div class="pos-rel-pdf">
                        <div class="pen-pos-abs">
                            <div class="pen-blue-box">
                                <div class="pdf-pos-rel">
                                    <div class="pdf-pos-abs-dot">
                                    </div>
                                    <p class="pdf-text-white">اعـرض شـريحة التعريـف بالمركـز السـعودي لألعمـال
                                        االقتصاديـة، ووضـح
                                        للمشـاركين ماهيـة
                                        المركـز ورؤيتـه وأهميتـه.</p>
                                </div>
                                <div class="pdf-pos-rel">
                                    <div class="pdf-pos-abs-dot">
                                    </div>
                                    <p class="pdf-text-white">اعـرض شـريحة التعريـف بالمركـز السـعودي لألعمـال
                                        االقتصاديـة، ووضـح
                                        للمشـاركين ماهيـة
                                        المركـز ورؤيتـه وأهميتـهلألعمـال االقتصاديـة، ووضـح للمشـاركين ماهيـة.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="container max-w-h bg-white-pdf my-2">
        <div class="p-pdf-bottom">
            <div class="px-6rem">
                <div class="d-flex">
                    <div class="b-bottom"></div>
                    <p class="pdf-text-desc">خدمات وزارة االسـتثمار</p>
                </div>
                <h6 class="pdf-heading my-5">الجدول المعرفي الذاتي KWL.</h6>
                <p class="pdf-text">هــذا الجــزء خــاص بــك كمشــارك، نأمــل أن تجيــب عــن األســئلة التــي تضمنتهــا
                    الحقيبــة قبــل بدايــة الــدورة
                    التدريبيـة، والعـودة إليهـا فـي نهايتهـا؛ للمقارنـة بيـن مـا كنـت تتوقـع معرفتـه، وبمـا حصلـت عليـه
                    مـن
                    معرفـة. </p>
                <div class="row p-0">
                    <div class="col-md-4 p-0">
                        <div class="d-flex flex-column">
                            <div class="balance-sheet-header">
                                ماذا أعرف؟ K
                            </div>
                            <div class="balance-sheet-box">
                                null
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4 p-0">
                        <div class="d-flex flex-column">
                            <div class="balance-sheet-header">
                                ماذا أريد أن أعرف؟ W
                            </div>
                            <div class="balance-sheet-box">
                                null
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4 p-0">
                        <div class="d-flex flex-column">
                            <div class="balance-sheet-header">
                                ماذا تعلمت؟ L
                            </div>
                            <div class="balance-sheet-box">
                                null
                            </div>
                        </div>
                    </div>
                </div>
                <div class="d-flex flex-column w-100 mtt-3rem">
                    <div class="d-flex pen-box">
                        <img class="pen-icon" src="../../../../assets/icons/SBC/penpaper.svg" alt="loading">
                        <h6 class="pdf-heading pen-icon-bar">إرشادات المدرب</h6>
                    </div>
                    <div class="pos-rel-pdf">
                        <div class="pen-pos-abs">
                            <div class="pen-blue-box">
                                <div class="pdf-pos-rel">
                                    <div class="pdf-pos-abs-dot">
                                    </div>
                                    <p class="pdf-text-white">اعـرض شـريحة التعريـف بالمركـز السـعودي لألعمـال
                                        االقتصاديـة، ووضـح
                                        للمشـاركين ماهيـة
                                        المركـز ورؤيتـه وأهميتـه.</p>
                                </div>
                                <div class="pdf-pos-rel">
                                    <div class="pdf-pos-abs-dot">
                                    </div>
                                    <p class="pdf-text-white">اعـرض شـريحة التعريـف بالمركـز السـعودي لألعمـال
                                        االقتصاديـة، ووضـح
                                        للمشـاركين ماهيـة
                                        المركـز ورؤيتـه وأهميتـهلألعمـال االقتصاديـة، ووضـح للمشـاركين ماهيـة.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="container max-w-h bg-white-pdf my-2">
        <div class="p-pdf-bottom">
            <div class="d-flex p-6rem">
                <img class="pdf-page-logo" src="../../../../assets/new-logo/SCBCLOGO-COLOR.svg" alt="loading">
                <div class="b-bottom"></div>
            </div>
            <!-- Profile bar sectio start -->
            <div class="d-flex w-100">
                <div class="">
                    <div class="d-flex">
                        <div class="pdf-profile pos-rel-pdf">
                            <img class="pdf-pp"
                                src="https://media.istockphoto.com/id/2061466428/photo/mid-century-modern-dining-area.webp?a=1&b=1&s=612x612&w=0&k=20&c=U1dsdSCgvYwZdGxcWRA3Z_WiF34-1aK98p5BK6mnko0="
                                alt="loading">
                        </div>
                    </div>
                </div>
                <div class="w-100">
                    <div class="d-flex align-items-baseline">
                        <div class="pp-bar-width-rel">
                            <div class="pp-bar-abs"></div>
                        </div>
                        <div class="d-flex flex-column w-100px">
                            <img class="pp-bar-icon" src="../../../../assets/icons/SBC/clock.svg" alt="loading">
                            <h6 class="pp-bar-text">10 دقيقة</h6>
                        </div>
                        <div class="pp-bar-width-rel">
                            <div class="pp-bar-abs"></div>
                        </div>
                        <div class="d-flex flex-column w-100px">
                            <img class="pp-bar-icon" src="../../../../assets/icons/SBC/clock.svg" alt="loading">
                            <h6 class="pp-bar-text">10 دقيقة</h6>
                        </div>
                    </div>
                    <div class="bar-2-reponse">
                        <div class="bar-2">
                            <img class="pp-bar-icon" src="../../../../assets/icons/SBC/clock.svg" alt="loading">
                            الحوار والمناقشة
                        </div>
                        <div class="bar-2">
                            <img class="pp-bar-icon" src="../../../../assets/icons/SBC/clock.svg" alt="loading">
                            المحاضرة
                        </div>
                        <div class="bar-2">
                            <img class="pp-bar-icon" src="../../../../assets/icons/SBC/clock.svg" alt="loading">
                            بطاقات تدريبية
                        </div>
                    </div>
                    <div class="d-flex">
                        <div class="d-flex flex-column">
                            <div class="bar-3">
                                نشاط
                            </div>
                            <div class="bar-3-num">1</div>
                        </div>
                        <div class="bar-3-blu-box">
                            نبذة عن وزارة االستثمار.
                        </div>
                    </div>
                </div>
            </div>
            <!-- Profile bar sectio end -->
            <div class="pos-rel-pdf">
                <div class="bar-logo">
                    <img class="bar-logo-img" src="../../../../assets/icons/SBC/mountain.svg" alt="loading">
                </div>
            </div>
            <div class="d-flex justify-content-center flex-column align-items-center mtt-3rem">
                <div class="bar-max-width">
                    <div>
                        <h6 class="pdf-heading-blue-mini">مع نهاية هذا النشاط بإذن الله، ستكون قادرا على أن:</h6>
                    </div>
                    <div class="d-flex align-items-baseline">
                        <div>
                            <div class="list-dot mrr-4"></div>
                        </div>
                        <p class="pdf-text">اإلرشـادات والتوجيهـات وضِ عـت لمسـاعدتك فـي</p>
                    </div>
                    <div class="d-flex align-items-baseline">
                        <div>
                            <div class="list-dot mrr-4"></div>
                        </div>
                        <p class="pdf-text">اإلرشـادات والتوجيهـات وضِ عـت لمسـاعدتك فـي تنفيـذ األنشـطة</p>
                    </div>
                </div>
            </div>
            <div class="px-5rem">
                <div class="d-flex align-items-baseline">
                    <div>
                        <div class="sky-num">1.</div>
                    </div>
                    <p class="pdf-text">اطلــع علــى المــادة العلميــة بعنــوان )نبــذة عــن وزارة االســتثمار(، وســجل
                        اســمك
                        ومعلومــة أثــارت
                        انتباهــك عــن الــوزارة فــي إحــدى األوراق الالصقــة وعلقهــا علــى لوحــة العــرض</p>
                </div>
                <div class="d-flex align-items-baseline">
                    <div>
                        <div class="sky-num">2.</div>
                    </div>
                    <p class="pdf-text">تنقل بين زمالئك في القاعة وتعرف عليهم واقرأ العبارات المعلقة على لوحة العرض.
                    </p>
                </div>
                <div class="d-flex align-items-baseline">
                    <div>
                        <div class="sky-num">3.</div>
                    </div>
                    <p class="pdf-text">ارجــع إلــى مقعــدك وعــرف بنفســك حينمــا يطلــب المــدرب واذكــر إحــدى
                        المعلومــات
                        المثيــرة التــي
                        أثــارت اهتمامــك حــول وزارة االســتثمار.</p>
                </div>
                <div class="d-flex flex-column">
                    <div class="papper-dotts"></div>
                    <div class="papper-dotts"></div>
                    <div class="papper-dotts"></div>
                    <div class="papper-dotts"></div>
                    <div class="papper-dotts"></div>
                    <div class="papper-dotts"></div>
                    <div class="papper-dotts"></div>
                    <div class="papper-dotts"></div>
                    <div class="papper-dotts"></div>
                </div>
            </div>
        </div>
    </div>

    <div class="container max-w-h bg-white-pdf my-2">
        <div class="p-pdf-bottom">
            <div class="d-flex p-6rem">
                <img class="pdf-page-logo" src="../../../../assets/new-logo/SCBCLOGO-COLOR.svg" alt="loading">
                <div class="b-bottom"></div>
            </div>
            <div class="px-5rem">
                <div class="d-flex justify-content-center">
                    <h6 class="pdf-heading mb-3rem">صالحيات وزارة االستثمار</h6>
                </div>
                <h6 class="pdf-heading-blue-mini d-flex">
                    مع نهاية هذا النشاط بإذن الله، ستكون قادرا على أن:
                    <div class="symbol">(1)</div>
                </h6>
                <div class="d-flex align-items-baseline mrr-4">
                    <div>
                        <div class="sky-num">1.</div>
                    </div>
                    <p class="pdf-text">اطلــع علــى المــادة العلميــة بعنــوان )نبــذة عــن وزارة االســتثمار(، وســجل
                        اســمك
                        ومعلومــة أثــارت
                        انتباهــك عــن الــوزارة فــي إحــدى األوراق الالصقــة وعلقهــا علــى لوحــة العــرض</p>
                </div>
                <div class="d-flex align-items-baseline mrr-4">
                    <div>
                        <div class="sky-num">2.</div>
                    </div>
                    <p class="pdf-text">. إيقـاع إحـدى العقوبـات الـواردة فـي المـادة الثانيـة عشـر فـي نظـام االسـتثمار
                        األجنبـي
                        فـي المملكـة
                        العربيــة الســعودية الصــادر بالمرســوم الملكــي رقــم )م/( وتاريخــه: )// هــ( إذا ثبــت بــأن
                        المســتثمر األجنبــي قــد ارتكــب مخالفــة مــن المخالفــات الــواردة فــي المــادة العشــرون
                        مــن الالئحــة
                        التنفيذيـة لنظـام االسـتثمار األجنبـي الصـادر بقـرار مجلـس إدارة الهيئـة العامـة لالسـتثمار
                        آنـذاك رقـم
                        )/( وتاريخــه: )// هــ(.
                    </p>
                </div>
                <div class="d-flex align-items-baseline mrr-4">
                    <div>
                        <div class="sky-num">3.</div>
                    </div>
                    <p class="pdf-text">ارجــع إلــى مقعــدك وعــرف بنفســك حينمــا يطلــب المــدرب واذكــر إحــدى
                        المعلومــات
                        المثيــرة التــي
                        أثــارت اهتمامــك حــول وزارة االســتثمار.</p>
                </div>
                <div class="d-flex align-items-baseline mrr-4">
                    <div>
                        <div class="sky-num">1.</div>
                    </div>
                    <p class="pdf-text">اطلــع علــى المــادة العلميــة بعنــوان )نبــذة عــن وزارة االســتثمار(، وســجل
                        اســمك
                        ومعلومــة أثــارت
                        انتباهــك عــن الــوزارة فــي إحــدى األوراق الالصقــة وعلقهــا علــى لوحــة العــرض</p>
                </div>
                <div class="d-flex align-items-baseline mrr-4">
                    <div>
                        <div class="sky-num">2.</div>
                    </div>
                    <p class="pdf-text">. إيقـاع إحـدى العقوبـات الـواردة فـي المـادة الثانيـة عشـر فـي نظـام االسـتثمار
                        األجنبـي
                        فـي المملكـة
                        العربيــة الســعودية الصــادر بالمرســوم الملكــي رقــم )م/( وتاريخــه: )// هــ( إذا ثبــت بــأن
                        المســتثمر األجنبــي قــد ارتكــب مخالفــة مــن المخالفــات الــواردة فــي المــادة العشــرون
                        مــن الالئحــة
                        التنفيذيـة لنظـام االسـتثمار األجنبـي الصـادر بقـرار مجلـس إدارة الهيئـة العامـة لالسـتثمار
                        آنـذاك رقـم
                        )/( وتاريخــه: )// هــ(.
                    </p>
                </div>
                <div class="d-flex align-items-baseline mrr-4">
                    <div>
                        <div class="sky-num">3.</div>
                    </div>
                    <p class="pdf-text">ارجــع إلــى مقعــدك وعــرف بنفســك حينمــا يطلــب المــدرب واذكــر إحــدى
                        المعلومــات
                        المثيــرة التــي
                        أثــارت اهتمامــك حــول وزارة االســتثمار.</p>
                </div>
                <div class="d-flex align-items-baseline mrr-4">
                    <div>
                        <div class="sky-num">1.</div>
                    </div>
                    <p class="pdf-text">اطلــع علــى المــادة العلميــة بعنــوان )نبــذة عــن وزارة االســتثمار(، وســجل
                        اســمك
                        ومعلومــة أثــارت
                        انتباهــك عــن الــوزارة فــي إحــدى األوراق الالصقــة وعلقهــا علــى لوحــة العــرض</p>
                </div>
                <div class="d-flex align-items-baseline mrr-4">
                    <div>
                        <div class="sky-num">2.</div>
                    </div>
                    <p class="pdf-text">. إيقـاع إحـدى العقوبـات الـواردة فـي المـادة الثانيـة عشـر فـي نظـام االسـتثمار
                        األجنبـي
                        فـي المملكـة
                        العربيــة الســعودية الصــادر بالمرســوم الملكــي رقــم )م/( وتاريخــه: )// هــ( إذا ثبــت بــأن
                        المســتثمر األجنبــي قــد ارتكــب مخالفــة مــن المخالفــات الــواردة فــي المــادة العشــرون
                        مــن الالئحــة
                        التنفيذيـة لنظـام االسـتثمار األجنبـي الصـادر بقـرار مجلـس إدارة الهيئـة العامـة لالسـتثمار
                        آنـذاك رقـم
                        )/( وتاريخــه: )// هــ(.
                    </p>
                </div>
                <div class="d-flex align-items-baseline mrr-4">
                    <div>
                        <div class="sky-num">3.</div>
                    </div>
                    <p class="pdf-text">ارجــع إلــى مقعــدك وعــرف بنفســك حينمــا يطلــب المــدرب واذكــر إحــدى
                        المعلومــات
                        المثيــرة التــي
                        أثــارت اهتمامــك حــول وزارة االســتثمار.</p>
                </div>
                <div class="d-flex flex-column mtt-3rem">
                    <div class="sign-bar"></div>
                    <p class="symbol">(1) دليل خدمات وزارة االستثمار، اإلصدار التاسع، )ص 144(. </p>
                </div>

            </div>
        </div>
    </div>

    <div class="container max-w-h bg-white-pdf my-2">
        <div class="p-pdf-bottom">
            <div class="px-6rem">
                <div class="d-flex">
                    <div class="b-bottom"></div>
                    <p class="pdf-text-desc">خدمات وزارة االسـتثمار</p>
                </div>
                <h6 class="pdf-heading my-5">الجدول المعرفي الذاتي KWL.</h6>
                <div class="bf-box pos-rel-pdf">
                    <div class="d-flex pos-abs-bf">
                        <img class="pen-icon" src="../../../../assets/icons/Email/24@1.5x.svg" alt="loading">
                        <div class="bf-text">
                            اإلجابة النموذجية
                        </div>
                    </div>
                    <div class="row p-0">
                        <div class="col-md-6 p-0">
                            <div class="d-flex flex-column">
                                <div class="balance-sheet-header">
                                    ماذا أعرف؟
                                </div>
                                <div class="balance-sheet-box-bf">
                                    ن عمليات التستر،
                                    والغش التجاري.
                                </div>
                                <div class="balance-sheet-box-bf">
                                    ألنها خارج اختصاص
                                    ن عمليات التستر،
                                </div>
                                <div class="balance-sheet-box-bf">
                                    ألنها خارج اختصاص
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6 p-0">
                            <div class="d-flex flex-column">
                                <div class="balance-sheet-header">
                                    لسبب أهميتها
                                </div>
                                <div class="balance-sheet-box-bf">
                                    ألنها تمنع ممارسة أعمال خارج اختصاص
                                    ا
                                </div>
                                <div class="balance-sheet-box-bf">
                                    ألنها تمنع ممارسة أعمال خارج اختصاص
                                    المستثمر، وتحمي من عمليات التستر،
                                    والغش التجاري.
                                </div>
                                <div class="balance-sheet-box-bf">
                                    ألنها خارج اختصاص
                                    ن عمليات التستر،
                                    والغش التجاري.
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>

    <div class="container max-w-h bg-white-pdf my-2">
        <div class="p-pdf-bottom">
            <div class="px-6rem">
                <div class="d-flex">
                    <div class="b-bottom"></div>
                    <p class="pdf-text-desc">خدمات وزارة االسـتثمار</p>
                </div>
                <div class="bf-text-sky mtt-3rem mb-3rem">
                    التواصل مع وزارة االستثمار:
                </div>
                <div class="d-flex align-items-baseline mrr-4">
                    <div>
                        <div class="list-dot"></div>
                    </div>
                    <p class="pdf-text">اطلــع علــى المــادة العلميــة بعنــوان )نبــذة عــن وزارة االســتثمار(، وســجل
                        اســمك
                        ومعلومــة أثــارت
                        انتباهــك عــن الــوزارة فــي إحــدى األوراق الالصقــة وعلقهــا علــى لوحــة العــرض</p>
                </div>
                <div class="d-flex align-items-baseline mrr-4">
                    <div>
                        <div class="list-dot"></div>
                    </div>
                    <p class="pdf-text">. إيقـاع إحـدى العقوبـات الـواردة فـي المـادة الثانيـة عشـر فـي نظـام االسـتثمار
                        األجنبـي
                        فـي المملكـة
                        العربيــة الســعودية الصــادر بالمرســوم الملكــي رقــم )م/( وتاريخــه: )// هــ( إذا ثبــت بــأن
                        المســتثمر األجنبــي قــد ارتكــب مخالفــة مــن المخالفــات الــواردة فــي المــادة العشــرون
                        مــن الالئحــة
                        التنفيذيـة لنظـام االسـتثمار األجنبـي الصـادر بقـرار مجلـس إدارة الهيئـة العامـة لالسـتثمار
                        آنـذاك رقـم
                        )/( وتاريخــه: )// هــ(.
                    </p>
                </div>
                <div class="d-flex align-items-baseline mrr-4">
                    <div>
                        <div class="list-dot"></div>
                    </div>
                    <p class="pdf-text">ارجــع إلــى مقعــدك وعــرف بنفســك حينمــا يطلــب المــدرب واذكــر إحــدى
                        المعلومــات
                        المثيــرة التــي
                        أثــارت اهتمامــك حــول وزارة االســتثمار.</p>
                </div>
                <div class="d-flex align-items-baseline mrr-4">
                    <div>
                        <div class="list-dot"></div>
                    </div>
                    <p class="pdf-text">اطلــع علــى المــادة العلميــة بعنــوان )نبــذة عــن وزارة االســتثمار(، وســجل
                        اســمك
                        ومعلومــة أثــارت
                        انتباهــك عــن الــوزارة فــي إحــدى األوراق الالصقــة وعلقهــا علــى لوحــة العــرض</p>
                </div>
                <div class="bf-box pos-rel-pdf mtt-3rem">
                    <div class="d-flex pos-abs-bf">
                        <img class="pen-icon" src="../../../../assets/icons/Email/24@1.5x.svg" alt="loading">
                        <div class="bf-text">
                            اإلجابة النموذجية
                        </div>
                    </div>
                    <p class="pdf-text">المعلومات التي سيذكرها المشاركين عن وزارة االستثمار متوفرة في المادة العلمية.
                    </p>
                </div>
            </div>
        </div>
    </div>

    <div class="container max-w-h bg-white-pdf my-2">
        <div class="p-pdf-bottom">
            <div class="d-flex p-6rem">
                <img class="pdf-page-logo" src="../../../../assets/new-logo/SCBCLOGO-COLOR.svg" alt="loading">
                <div class="b-bottom"></div>
            </div>
            <!-- Profile bar sectio start -->
            <div class="d-flex w-100">
                <div class="">
                    <div class="d-flex">
                        <div class="pdf-profile pos-rel-pdf">
                            <img class="pdf-pp"
                                src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT3dG3xJm6hiiYXGu9sEq7XBT7a_iY9Jg721zow_XydsVEtqP77iax0bVvvvaUWmagpN-k&usqp=CAU"
                                alt="loading">
                        </div>
                    </div>
                </div>
                <div class="w-100">
                    <div class="d-flex align-items-baseline">
                        <div class="pp-bar-width-rel">
                            <div class="pp-bar-abs"></div>
                        </div>
                        <div class="d-flex flex-column w-100px">
                            <img class="pp-bar-icon" src="../../../../assets/icons/SBC/clock.svg" alt="loading">
                            <h6 class="pp-bar-text">10 دقيقة</h6>
                        </div>
                        <div class="pp-bar-width-rel">
                            <div class="pp-bar-abs"></div>
                        </div>
                        <div class="d-flex flex-column w-100px">
                            <img class="pp-bar-icon" src="../../../../assets/icons/SBC/clock.svg" alt="loading">
                            <h6 class="pp-bar-text">10 دقيقة</h6>
                        </div>
                    </div>
                    <div class="bar-2-reponse">
                        <div class="bar-2">
                            <img class="pp-bar-icon" src="../../../../assets/icons/SBC/clock.svg" alt="loading">
                            الحوار والمناقشة
                        </div>
                        <div class="bar-2">
                            <img class="pp-bar-icon" src="../../../../assets/icons/SBC/clock.svg" alt="loading">
                            المحاضرة
                        </div>
                        <div class="bar-2">
                            <img class="pp-bar-icon" src="../../../../assets/icons/SBC/clock.svg" alt="loading">
                            بطاقات تدريبية
                        </div>
                    </div>
                    <div class="d-flex">
                        <div class="d-flex flex-column">
                            <div class="bar-3">
                                نشاط
                            </div>
                            <div class="bar-3-num">1</div>
                        </div>
                        <div class="bar-3-blu-box">
                            نبذة عن وزارة االستثمار.
                        </div>
                    </div>
                </div>
            </div>
            <!-- Profile bar sectio end -->
            <div class="pos-rel-pdf">
                <div class="bar-logo">
                    <img class="bar-logo-img" src="../../../../assets/icons/SBC/mountain.svg" alt="loading">
                </div>
            </div>
            <div class="d-flex justify-content-center flex-column align-items-center mtt-3rem">
                <div class="bar-max-width">
                    <div>
                        <h6 class="pdf-heading-blue-mini">مع نهاية هذا النشاط بإذن الله، ستكون قادرا على أن:</h6>
                    </div>
                    <div class="d-flex align-items-baseline">
                        <div>
                            <div class="list-dot mrr-4"></div>
                        </div>
                        <p class="pdf-text">اإلرشـادات والتوجيهـات وضِ عـت لمسـاعدتك فـي</p>
                    </div>
                    <div class="d-flex align-items-baseline">
                        <div>
                            <div class="list-dot mrr-4"></div>
                        </div>
                        <p class="pdf-text">اإلرشـادات والتوجيهـات وضِ عـت لمسـاعدتك فـي تنفيـذ األنشـطة</p>
                    </div>
                </div>
            </div>
            <div class="px-6rem">
                <div class="row p-0">
                    <div class="col-md-6 p-0">
                        <div class="d-flex flex-column">
                            <div class="balance-sheet-header">
                                ماذا أعرف؟
                            </div>
                            <div class="balance-sheet-box-bf">
                                ن عمليات التستر،
                                والغش التجاري.
                            </div>
                            <div class="balance-sheet-box-bf">
                                ألنها خارج اختصاص
                                ن عمليات التستر،
                            </div>
                            <div class="balance-sheet-box-bf">
                                ألنها خارج اختصاص
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6 p-0">
                        <div class="d-flex flex-column">
                            <div class="balance-sheet-header">
                                لسبب أهميتها
                            </div>
                            <div class="balance-sheet-box-bf">
                                ألنها تمنع ممارسة أعمال خارج اختصاص
                                ا
                            </div>
                            <div class="balance-sheet-box-bf">
                                ألنها تمنع ممارسة أعمال خارج اختصاص
                                المستثمر، وتحمي من عمليات التستر،
                                والغش التجاري.
                            </div>
                            <div class="balance-sheet-box-bf">
                                ألنها خارج اختصاص
                                ن عمليات التستر،
                                والغش التجاري.
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="container max-w-h bg-white-pdf my-2">
        <div class="p-pdf-bottom">
            <div class="d-flex p-6rem">
                <img class="pdf-page-logo" src="../../../../assets/new-logo/SCBCLOGO-COLOR.svg" alt="loading">
                <div class="b-bottom"></div>
            </div>
            <div class="px-5rem">
                <div class="d-flex justify-content-center">
                    <h6 class="pdf-heading mb-3rem">خالصة الجلسة التدريبية</h6>
                </div>
                <div class="d-flex align-items-baseline">
                    <div>
                        <div class="list-dot"></div>
                    </div>
                    <p class="pdf-text">تطــور تنظيــم االســتثمار فــي المملكــة بشــكل متســارع فــي الفتــرة
                        األخيــرة؛ حيــث
                        يتضــح تنــوع
                        وانفتــاح االقتصــاد فــي المملكــة وتطــور التشــريعات المنظمــة لالســتثمار، إضافــة إلــى
                        توافــر بيئــة
                        آمنـة ومسـتقرة، كمـا سـعت الـوزارة إلـى تقديـم الخدمـات بشـكل إلكترونـي للمسـتثمرين حسـب نـوع
                        المســتثمر )حالــي، جديــد( وأتمتــة العديــد مــن هــذه الخدمــات لخدمــة المســتثمرين وتســريع
                        إجراءاتهــم.</p>
                </div>
                <!-- rectraaingle-diagram start -->
                <div class="d-flex align-items-center flex-column">
                    <div class="rect-padding pos-rel-pdf">
                        <i class="pos-abs-square-top fa-solid fa-caret-up"></i>
                        <div class="outer-div-1">
                            <p class="pdf-text-z-index">تطــور تنظيــم االســتثمار فــي المملكــة بشــكل متســارع فــي
                                الفتــرة
                            <div class="inner-div-1"></div>
                        </div>
                    </div>
                    <div class="">
                        <div class="outer-div-2">
                            <p class="pdf-text-z-index-2">تطــور تنظيــم االســتثمار فــي المملكــة بشــكل متســارع فــي
                                الفتــرة
                            <div class="inner-div-2"></div>
                        </div>
                    </div>
                    <div class="rect-padding pos-rel-pdf">
                        <i class="pos-abs-square-bottom fa-solid fa-caret-up"></i>
                        <div class="outer-div-1">
                            <p class="pdf-text-z-index">تطــور تنظيــم االســتثمار فــي المملكــة بشــكل متســارع فــي
                                الفتــرة
                            <div class="inner-div-1"></div>
                        </div>
                    </div>
                </div>
                <!-- rectraaingle-diagram end -->
            </div>
        </div>
    </div>

    <div class="container max-w-h bg-white-pdf my-2">
        <div class="p-pdf-bottom">
            <div class="d-flex p-6rem">
                <img class="pdf-page-logo" src="../../../../assets/new-logo/SCBCLOGO-COLOR.svg" alt="loading">
                <div class="b-bottom"></div>
            </div>
            <!-- Profile bar sectio start -->
            <div class="d-flex w-100">
                <div class="">
                    <div class="d-flex">
                        <div class="pdf-profile pos-rel-pdf">
                            <img class="pdf-pp"
                                src="https://images.unsplash.com/photo-1738676469786-6fe6c1acabf2?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxmZWF0dXJlZC1waG90b3MtZmVlZHwxMXx8fGVufDB8fHx8fA%3D%3D"
                                alt="loading">
                        </div>
                    </div>
                </div>
                <div class="w-100">
                    <div class="d-flex align-items-baseline">
                        <div class="pp-bar-width-rel">
                            <div class="pp-bar-abs"></div>
                        </div>
                        <div class="d-flex flex-column w-100px">
                            <img class="pp-bar-icon" src="../../../../assets/icons/SBC/clock.svg" alt="loading">
                            <h6 class="pp-bar-text">10 دقيقة</h6>
                        </div>
                        <div class="pp-bar-width-rel">
                            <div class="pp-bar-abs"></div>
                        </div>
                        <div class="d-flex flex-column w-100px">
                            <img class="pp-bar-icon" src="../../../../assets/icons/SBC/clock.svg" alt="loading">
                            <h6 class="pp-bar-text">10 دقيقة</h6>
                        </div>
                    </div>
                    <div class="bar-2-reponse">
                        <div class="bar-2">
                            <img class="pp-bar-icon" src="../../../../assets/icons/SBC/clock.svg" alt="loading">
                            الحوار والمناقشة
                        </div>
                        <div class="bar-2">
                            <img class="pp-bar-icon" src="../../../../assets/icons/SBC/clock.svg" alt="loading">
                            المحاضرة
                        </div>
                        <div class="bar-2">
                            <img class="pp-bar-icon" src="../../../../assets/icons/SBC/clock.svg" alt="loading">
                            بطاقات تدريبية
                        </div>
                    </div>
                    <div class="d-flex">
                        <div class="d-flex flex-column">
                            <div class="bar-3">
                                نشاط
                            </div>
                            <div class="bar-3-num">1</div>
                        </div>
                        <div class="bar-3-blu-box">
                            نبذة عن وزارة االستثمار.
                        </div>
                    </div>
                </div>
            </div>
            <!-- Profile bar sectio end -->
            <div class="pos-rel-pdf">
                <div class="bar-logo">
                    <img class="bar-logo-img" src="../../../../assets/icons/SBC/mountain.svg" alt="loading">
                </div>
            </div>
            <div class="d-flex justify-content-center flex-column align-items-center mtt-3rem">
                <div class="bar-max-width">
                    <div>
                        <h6 class="pdf-heading-blue-mini">مع نهاية هذا النشاط بإذن الله، ستكون قادرا على أن:</h6>
                    </div>
                    <div class="d-flex align-items-baseline">
                        <div>
                            <div class="list-dot mrr-4"></div>
                        </div>
                        <p class="pdf-text">اإلرشـادات والتوجيهـات وضِ عـت لمسـاعدتك فـي</p>
                    </div>
                    <div class="d-flex align-items-baseline">
                        <div>
                            <div class="list-dot mrr-4"></div>
                        </div>
                        <p class="pdf-text">اإلرشـادات والتوجيهـات وضِ عـت لمسـاعدتك فـي تنفيـذ األنشـطة</p>
                    </div>
                </div>
            </div>
            <div class="px-6rem">
                <div class="outer-div">
                    <p class="pdf-text-z-index">تطــور تنظيــم االســتثمار فــي المملكــة بشــكل متســارع فــي الفتــرة
                        األخيــرة؛
                        حيــث يتضــح تنــوع
                        وانفتــاح االقتصــاد فــي المملكــة وتطــور التشــريعات المنظمــة لالســتثمار، إضافــة إلــى
                        توافــر بيئــة
                        آمنـة ومسـتقرة، كمـا سـعت الـوزارة إلـى تقديـم الخدمـات بشـكل إلكترونـي للمسـتثمرين حسـب نـوع
                        المســتثمر )حالــي، جديــد( وأتمتــة العديــد مــن هــذه الخدمــات لخدمــة المســتثمرين وتســريع
                        إجراءاتهــم.</p>
                    <div class="inner-div"></div>
                </div>
            </div>
        </div>
    </div>

    <div class="container max-w-h bg-white-pdf my-2">
        <div class="p-pdf-bottom">
            <div class="d-flex p-6rem">
                <img class="pdf-page-logo" src="../../../../assets/new-logo/SCBCLOGO-COLOR.svg" alt="loading">
                <div class="b-bottom"></div>
            </div>
            <div class="px-6rem">
                <div>
                    <p class="pdf-text">اإلرشـادات والتوجيهـات وضِ عـت لمسـاعدتك</p>
                </div>
                <div class="d-flex align-items-baseline">
                    <div>
                        <div class="list-dot mrr-4"></div>
                    </div>
                    <p class="pdf-text">اإلرشـادات والتوجيهـات وضِ عـت لمسـاعدتك فـي</p>
                </div>
                <div class="d-flex align-items-baseline">
                    <div>
                        <div class="list-dot mrr-4"></div>
                    </div>
                    <p class="pdf-text">اإلرشـادات والتوجيهـات وضِ عـت لمسـاعدتك فـي تنفيـذ األنشـطة</p>
                </div>
                <div class="my-3">
                    <h6 class="pdf-heading-sky-mini">مع نهاية هذا النشاط بإذن الله، ستكون قادرا على أن:</h6>
                    <p class="pdf-text">اإلرشـادات والتوجيهـات وضِ عـت لمسـاعدتك فـي تنفيـذ مع نهاية هذا النشاط بإذن
                        الله، ستكون
                        قادرا على أن:اإلرشـادات والتوجيهـات وضِ عـت لمسـاعدتك فـي تنفيـذ مع نهاية هذا النشاط بإذن الله،
                        ستكون قادرا
                        على أن:</p>
                </div>
                <div class="d-flex justify-content-center flex-wrap">
                    <div class="d-flex align-items-center mx-2">
                        <div class="d-flex flex-column numaric-max-w">
                            <div class="numaric-circle-num">01</div>
                            <div class="d-flex">
                                <div class="numaric-circle"><i class="numaric-icon pi pi-desktop"></i></div>
                            </div>
                            <p class="pdf-text">النشاط بإذن</p>
                        </div>
                        <div>
                            <i class="numaric-left-arrow fa-solid fa-arrow-left-long"></i>
                        </div>
                    </div>
                    <div class="d-flex align-items-center mx-2">
                        <div class="d-flex flex-column numaric-max-w">
                            <div class="numaric-circle-num">02</div>
                            <div class="d-flex">
                                <div class="numaric-circle"><i class="numaric-icon pi pi-android"></i></div>
                            </div>
                            <p class="pdf-text">النشاط بإذن</p>
                        </div>
                        <div>
                            <i class="numaric-left-arrow fa-solid fa-arrow-left-long"></i>
                        </div>
                    </div>
                    <div class="d-flex align-items-center mx-2">
                        <div class="d-flex flex-column numaric-max-w">
                            <div class="numaric-circle-num">03</div>
                            <div class="d-flex">
                                <div class="numaric-circle"><i class="numaric-icon pi pi-wallet"></i></div>
                            </div>
                            <p class="pdf-text">النشاط بإذن</p>
                        </div>
                        <div>
                            <i class="numaric-left-arrow fa-solid fa-arrow-left-long"></i>
                        </div>
                    </div>
                    <div class="d-flex align-items-center mx-2">
                        <div class="d-flex flex-column numaric-max-w">
                            <div class="numaric-circle-num">04</div>
                            <div class="d-flex">
                                <div class="numaric-circle"><i class="numaric-icon pi pi-bitcoin"></i></div>
                            </div>
                            <p class="pdf-text">النشاط بإذن</p>
                        </div>
                        <div>
                            <i class="numaric-left-arrow fa-solid fa-arrow-left-long"></i>
                        </div>
                    </div>
                    <div class="d-flex align-items-center mx-2">
                        <div class="d-flex flex-column numaric-max-w">
                            <div class="numaric-circle-num">05</div>
                            <div class="d-flex">
                                <div class="numaric-circle"><i class="numaric-icon pi pi-apple"></i></div>
                            </div>
                            <p class="pdf-text">النشاط بإذن</p>
                        </div>
                    </div>

                </div>
                <div class="bf-box pos-rel-pdf mtt-3rem">
                    <div class="d-flex pos-abs-bf">
                        <img class="pen-icon" src="../../../../assets/icons/Email/24@1.5x.svg" alt="loading">
                        <div class="bf-text">
                            اإلجابة النموذجية
                        </div>
                    </div>
                    <p class="pdf-text">المعلومات التي سيذكرها المشاركين عن وزارة االستثمار متوفرة في المادة العلمية.
                    </p>
                </div>
            </div>
        </div>
    </div>

    <div class="container max-w-h bg-white-pdf my-2">
        <div class="p-pdf-bottom">
            <div class="d-flex p-6rem">
                <img class="pdf-page-logo" src="../../../../assets/new-logo/SCBCLOGO-COLOR.svg" alt="loading">
                <div class="b-bottom"></div>
            </div>
            <div class="px-5rem">
                <div class="d-flex justify-content-center">
                    <h6 class="pdf-heading mb-3rem">خالصة الجلسة التدريبية</h6>
                </div>
                <div class="d-flex align-items-baseline">
                    <div>
                        <div class="list-dot"></div>
                    </div>
                    <p class="pdf-text">تطــور تنظيــم االســتثمار فــي المملكــة بشــكل متســارع فــي الفتــرة
                        األخيــرة؛ حيــث
                        يتضــح تنــوع
                        وانفتــاح االقتصــاد فــي المملكــة وتطــور التشــريعات المنظمــة لالســتثمار، إضافــة إلــى
                        توافــر بيئــة
                        آمنـة ومسـتقرة، كمـا سـعت الـوزارة إلـى تقديـم الخدمـات بشـكل إلكترونـي للمسـتثمرين حسـب نـوع
                        المســتثمر )حالــي، جديــد( وأتمتــة العديــد مــن هــذه الخدمــات لخدمــة المســتثمرين وتســريع
                        إجراءاتهــم.</p>
                </div>
                <!-- circle diagram start -->
                <div class="container-box mtt-3rem">
                    <div class="circle-border">
                        <div class="circle pos-rel-pdf">الخدمات الإلكترونية
                            <i class="pos-abs-circle-top fa-solid fa-caret-up"></i>
                        </div>
                    </div>
                    <div class="box my-3">
                        تطــور تنظيــم االســتثمار فــي المملكــة بشــكل</div>
                    <div class="circle-border">
                        <div class="circle pos-rel-pdf">مراحل تطور الاستثمار في المملكة
                            <i class="pos-abs-circle-bottom fa-solid fa-caret-up"></i>
                        </div>
                    </div>
                </div>
                <!-- circle-diagram end -->
            </div>
        </div>
    </div>

    <div class="container max-w-h bg-white-pdf my-2">
        <div class="p-pdf-bottom">
            <div class="d-flex p-6rem">
                <img class="pdf-page-logo" src="../../../../assets/new-logo/SCBCLOGO-COLOR.svg" alt="loading">
                <div class="b-bottom"></div>
            </div>
            <!-- Profile bar sectio start -->
            <div class="d-flex w-100">
                <div class="">
                    <div class="d-flex">
                        <div class="pdf-profile pos-rel-pdf">
                            <img class="pdf-pp"
                                src="https://images.unsplash.com/photo-1738676469786-6fe6c1acabf2?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxmZWF0dXJlZC1waG90b3MtZmVlZHwxMXx8fGVufDB8fHx8fA%3D%3D"
                                alt="loading">
                        </div>
                    </div>
                </div>
                <div class="w-100">
                    <div class="d-flex align-items-baseline">
                        <div class="pp-bar-width-rel">
                            <div class="pp-bar-abs"></div>
                        </div>
                        <div class="d-flex flex-column w-100px">
                            <img class="pp-bar-icon" src="../../../../assets/icons/SBC/clock.svg" alt="loading">
                            <h6 class="pp-bar-text">10 دقيقة</h6>
                        </div>
                        <div class="pp-bar-width-rel">
                            <div class="pp-bar-abs"></div>
                        </div>
                        <div class="d-flex flex-column w-100px">
                            <img class="pp-bar-icon" src="../../../../assets/icons/SBC/clock.svg" alt="loading">
                            <h6 class="pp-bar-text">10 دقيقة</h6>
                        </div>
                    </div>
                    <div class="bar-2-reponse">
                        <div class="bar-2">
                            <img class="pp-bar-icon" src="../../../../assets/icons/SBC/clock.svg" alt="loading">
                            الحوار والمناقشة
                        </div>
                        <div class="bar-2">
                            <img class="pp-bar-icon" src="../../../../assets/icons/SBC/clock.svg" alt="loading">
                            المحاضرة
                        </div>
                        <div class="bar-2">
                            <img class="pp-bar-icon" src="../../../../assets/icons/SBC/clock.svg" alt="loading">
                            بطاقات تدريبية
                        </div>
                    </div>
                    <div class="d-flex">
                        <div class="d-flex flex-column">
                            <div class="bar-3">
                                نشاط
                            </div>
                            <div class="bar-3-num">1</div>
                        </div>
                        <div class="bar-3-blu-box">
                            نبذة عن وزارة االستثمار.
                        </div>
                    </div>
                </div>
            </div>
            <!-- Profile bar sectio end -->
            <div class="pos-rel-pdf">
                <div class="bar-logo">
                    <img class="bar-logo-img" src="../../../../assets/icons/SBC/mountain.svg" alt="loading">
                </div>
            </div>
            <div class="d-flex justify-content-center flex-column align-items-center mtt-3rem">
                <div class="bar-max-width">
                    <div>
                        <h6 class="pdf-heading-blue-mini">مع نهاية هذا النشاط بإذن الله، ستكون قادرا على أن:</h6>
                    </div>
                    <div class="d-flex align-items-baseline">
                        <div>
                            <div class="list-dot mrr-4"></div>
                        </div>
                        <p class="pdf-text">اإلرشـادات والتوجيهـات وضِ عـت لمسـاعدتك فـي</p>
                    </div>
                    <div class="d-flex align-items-baseline">
                        <div>
                            <div class="list-dot mrr-4"></div>
                        </div>
                        <p class="pdf-text">اإلرشـادات والتوجيهـات وضِ عـت لمسـاعدتك فـي تنفيـذ األنشـطة</p>
                    </div>
                </div>
            </div>
            <div class="px-6rem">
                <div class="grey-box-pdf my-3">
                    <div class="border-box-pdf">
                        <div class="d-flex justify-content-center pos-rel-pdf">
                            <div class="border-heading">
                                مجموعة أنواع االستثمار
                            </div>
                        </div>
                        <p class="pdf-text my-3">ما أنواع االستثمار في المملكة؟ </p>
                        <div class="d-flex flex-column">
                            <div class="papper-dotts"></div>
                            <div class="papper-dotts"></div>
                            <div class="papper-dotts"></div>
                            <div class="papper-dotts"></div>
                        </div>
                        <p class="pdf-text">ما أنواع االستثمار في المملكة؟ </p>
                        <div class="d-flex flex-column">
                            <div class="papper-dotts"></div>
                            <div class="papper-dotts"></div>
                            <div class="papper-dotts"></div>
                            <div class="papper-dotts"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="container max-w-h bg-white-pdf my-2">
        <div class="p-pdf-bottom">
            <div class="d-flex p-6rem">
                <img class="pdf-page-logo" src="../../../../assets/new-logo/SCBCLOGO-COLOR.svg" alt="loading">
                <div class="b-bottom"></div>
            </div>
            <!-- Profile bar sectio start -->
            <div class="d-flex w-100">
                <div class="">
                    <div class="d-flex">
                        <div class="pdf-profile pos-rel-pdf">
                            <img class="pdf-pp"
                                src="https://images.unsplash.com/photo-1738676469786-6fe6c1acabf2?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxmZWF0dXJlZC1waG90b3MtZmVlZHwxMXx8fGVufDB8fHx8fA%3D%3D"
                                alt="loading">
                        </div>
                    </div>
                </div>
                <div class="w-100">
                    <div class="d-flex align-items-baseline">
                        <div class="pp-bar-width-rel">
                            <div class="pp-bar-abs"></div>
                        </div>
                        <div class="d-flex flex-column w-100px">
                            <img class="pp-bar-icon" src="../../../../assets/icons/SBC/clock.svg" alt="loading">
                            <h6 class="pp-bar-text">10 دقيقة</h6>
                        </div>
                        <div class="pp-bar-width-rel">
                            <div class="pp-bar-abs"></div>
                        </div>
                        <div class="d-flex flex-column w-100px">
                            <img class="pp-bar-icon" src="../../../../assets/icons/SBC/clock.svg" alt="loading">
                            <h6 class="pp-bar-text">10 دقيقة</h6>
                        </div>
                    </div>
                    <div class="bar-2-reponse">
                        <div class="bar-2">
                            <img class="pp-bar-icon" src="../../../../assets/icons/SBC/clock.svg" alt="loading">
                            الحوار والمناقشة
                        </div>
                        <div class="bar-2">
                            <img class="pp-bar-icon" src="../../../../assets/icons/SBC/clock.svg" alt="loading">
                            المحاضرة
                        </div>
                        <div class="bar-2">
                            <img class="pp-bar-icon" src="../../../../assets/icons/SBC/clock.svg" alt="loading">
                            بطاقات تدريبية
                        </div>
                    </div>
                    <div class="d-flex">
                        <div class="d-flex flex-column">
                            <div class="bar-3">
                                نشاط
                            </div>
                            <div class="bar-3-num">1</div>
                        </div>
                        <div class="bar-3-blu-box">
                            نبذة عن وزارة االستثمار.
                        </div>
                    </div>
                </div>
            </div>
            <!-- Profile bar sectio end -->
            <div class="pos-rel-pdf">
                <div class="bar-logo">
                    <img class="bar-logo-img" src="../../../../assets/icons/SBC/mountain.svg" alt="loading">
                </div>
            </div>
            <div class="d-flex justify-content-center flex-column align-items-center mtt-3rem">
                <div class="bar-max-width">
                    <div>
                        <h6 class="pdf-heading-blue-mini">مع نهاية هذا النشاط بإذن الله، ستكون قادرا على أن:</h6>
                    </div>
                    <div class="d-flex align-items-baseline">
                        <div>
                            <div class="list-dot mrr-4"></div>
                        </div>
                        <p class="pdf-text">اإلرشـادات والتوجيهـات وضِ عـت لمسـاعدتك فـي</p>
                    </div>
                    <div class="d-flex align-items-baseline">
                        <div>
                            <div class="list-dot mrr-4"></div>
                        </div>
                        <p class="pdf-text">اإلرشـادات والتوجيهـات وضِ عـت لمسـاعدتك فـي تنفيـذ األنشـطة</p>
                    </div>
                </div>
            </div>
            <div class="px-6rem">
                <div class="row p-0 my-3">
                    <div class="col-md-4 p-0">
                        <div class="d-flex align-items-center flex-column grey-logo-box">
                            <img class="grey-logo-img" src="../../../../assets/logo.png" alt="loading">
                            <p class="grey-logo-text">الترخيص الزراعي.</p>
                        </div>
                    </div>
                    <div class="col-md-4 p-0">
                        <div class="d-flex align-items-center flex-column grey-logo-box">
                            <img class="grey-logo-img" src="../../../../assets/logo.png" alt="loading">
                            <p class="grey-logo-text">الترخيص الزراعي.</p>
                        </div>
                    </div>
                    <div class="col-md-4 p-0">
                        <div class="d-flex align-items-center flex-column grey-logo-box">
                            <img class="grey-logo-img" src="../../../../assets/logo.png" alt="loading">
                            <p class="grey-logo-text">الترخيص الزراعي.</p>
                        </div>
                    </div>
                    <div class="col-md-4 p-0">
                        <div class="d-flex align-items-center flex-column grey-logo-box">
                            <img class="grey-logo-img" src="../../../../assets/logo.png" alt="loading">
                            <p class="grey-logo-text">الترخيص الزراعي.</p>
                        </div>
                    </div>
                    <div class="col-md-4 p-0">
                        <div class="d-flex align-items-center flex-column grey-logo-box">
                            <img class="grey-logo-img" src="../../../../assets/logo.png" alt="loading">
                            <p class="grey-logo-text">الترخيص الزراعي.</p>
                        </div>
                    </div>
                    <div class="col-md-4 p-0">
                        <div class="d-flex align-items-center flex-column grey-logo-box">
                            <img class="grey-logo-img" src="../../../../assets/logo.png" alt="loading">
                            <p class="grey-logo-text">الترخيص الزراعي.</p>
                        </div>
                    </div>
                    <div class="col-md-4 p-0">
                        <div class="d-flex align-items-center flex-column grey-logo-box">
                            <img class="grey-logo-img" src="../../../../assets/logo.png" alt="loading">
                            <p class="grey-logo-text">الترخيص الزراعي.</p>
                        </div>
                    </div>
                    <div class="col-md-4 p-0">
                        <div class="d-flex align-items-center flex-column grey-logo-box">
                            <img class="grey-logo-img" src="../../../../assets/logo.png" alt="loading">
                            <p class="grey-logo-text">الترخيص الزراعي.</p>
                        </div>
                    </div>
                    <div class="col-md-4 p-0">
                        <div class="d-flex align-items-center flex-column grey-logo-box">
                            <img class="grey-logo-img" src="../../../../assets/logo.png" alt="loading">
                            <p class="grey-logo-text">الترخيص الزراعي.</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="container max-w-h bg-white-pdf my-2">
        <div class="p-pdf-bottom">
            <div class="d-flex p-6rem">
                <img class="pdf-page-logo" src="../../../../assets/new-logo/SCBCLOGO-COLOR.svg" alt="loading">
                <div class="b-bottom"></div>
            </div>
            <div class="px-5rem">
                <div class="grey-box-pdf my-3">
                    <div class="border-box-pdf">
                        <div class="d-flex justify-content-center pos-rel-pdf">
                            <div class="border-heading">
                                مجموعة أنواع االستثمار
                            </div>
                        </div>
                        <p class="pdf-text my-3">ما أنواع االستثمار في المملكة؟ </p>
                        <div class="d-flex flex-column">
                            <div class="papper-dotts"></div>
                            <div class="papper-dotts"></div>
                            <div class="papper-dotts"></div>
                            <div class="papper-dotts"></div>
                        </div>
                        <p class="pdf-text">ما أنواع االستثمار في المملكة؟ </p>
                        <div class="row row-bg">
                            <div class="col-md-6 p-0">
                                <div class="d-flex flex-column">
                                    <div class="balance-sheet-header">
                                        ماذا أعرف؟
                                    </div>
                                    <div class="balance-sheet-box-bf">
                                        ن عمليات التستر،
                                        والغش التجاري.
                                    </div>
                                    <div class="balance-sheet-box-bf">
                                        ألنها خارج اختصاص
                                        ن عمليات التستر،
                                    </div>
                                    <div class="balance-sheet-box-bf">
                                        ألنها خارج اختصاص
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6 p-0">
                                <div class="d-flex flex-column">
                                    <div class="balance-sheet-header">
                                        لسبب أهميتها
                                    </div>
                                    <div class="balance-sheet-box-bf">
                                        ألنها تمنع ممارسة أعمال خارج اختصاص
                                        ا
                                    </div>
                                    <div class="balance-sheet-box-bf">
                                        ألنها تمنع ممارسة أعمال خارج اختصاص
                                        المستثمر، وتحمي من عمليات التستر،
                                        والغش التجاري.
                                    </div>
                                    <div class="balance-sheet-box-bf">
                                        ألنها خارج اختصاص
                                        ن عمليات التستر،
                                        والغش التجاري.
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="container max-w-h bg-white-pdf my-2">
        <div class="p-pdf-bottom">
            <div class="d-flex p-6rem">
                <img class="pdf-page-logo" src="../../../../assets/new-logo/SCBCLOGO-COLOR.svg" alt="loading">
                <div class="b-bottom"></div>
            </div>
            <div class="px-5rem">
                <div class="bf-box pos-rel-pdf mtt-3rem">
                    <div class="d-flex pos-abs-bf">
                        <img class="pen-icon" src="../../../../assets/icons/Email/24@1.5x.svg" alt="loading">
                        <div class="bf-text">
                            اإلجابة النموذجية
                        </div>
                    </div>
                    <div class="grey-box-pdf my-3">
                        <div class="border-box-pdf">
                            <div class="d-flex justify-content-center pos-rel-pdf">
                                <div class="border-heading">
                                    مجموعة أنواع االستثمار
                                </div>
                            </div>
                            <p class="pdf-text my-3">ما أنواع االستثمار في المملكة؟ </p>
                            <div class="d-flex align-items-baseline mrr-4">
                                <div>
                                    <div class="list-dot"></div>
                                </div>
                                <p class="pdf-text"> اطلـع علـى اإلرشـادات والتوجيهـات فـي حقيبـة المـدرب، فهـي ستسـاهم
                                    بـإذن اللـه فـي
                                    توضيـح
                                    مـا</p>
                            </div>
                            <div class="d-flex align-items-baseline mrr-4">
                                <div>
                                    <div class="list-dot"></div>
                                </div>
                                <p class="pdf-text"> اطلـع علـى اإلرشـادات والتوجيهـات فـي حقيبـة المـدرب، فهـي ستسـاهم
                                    بـإذن اللـه فـي
                                    توضيـح
                                    مـا</p>
                            </div>
                            <p class="pdf-text">ما أنواع االستثمار في المملكة؟ </p>

                        </div>
                    </div>
                    <div class="grey-box-pdf my-3">
                        <div class="border-box-pdf">
                            <div class="d-flex justify-content-center pos-rel-pdf">
                                <div class="border-heading">
                                    مجموعة أنواع االستثمار
                                </div>
                            </div>
                            <p class="pdf-text my-3">ما أنواع االستثمار في المملكة؟ </p>
                            <div class="d-flex align-items-baseline mrr-4">
                                <div>
                                    <div class="list-dot"></div>
                                </div>
                                <p class="pdf-text"> اطلـع علـى اإلرشـادات والتوجيهـات فـي حقيبـة المـدرب، فهـي ستسـاهم
                                    بـإذن اللـه فـي
                                    توضيـح
                                    مـا</p>
                            </div>
                            <div class="d-flex align-items-baseline mrr-4">
                                <div>
                                    <div class="list-dot"></div>
                                </div>
                                <p class="pdf-text"> اطلـع علـى اإلرشـادات والتوجيهـات فـي حقيبـة المـدرب، فهـي ستسـاهم
                                    بـإذن اللـه فـي
                                    توضيـح
                                    مـا</p>
                            </div>
                            <p class="pdf-text">ما أنواع االستثمار في المملكة؟ </p>
                        </div>
                    </div>
                    <div class="grey-box-pdf my-3">
                        <div class="border-box-pdf">
                            <div class="d-flex justify-content-center pos-rel-pdf">
                                <div class="border-heading">
                                    مجموعة الكيانات القانونية األكثر طلبا لتراخيص
                                    االستثمار في وزارة االستثمار
                                </div>
                            </div>
                            <p class="pdf-text my-3">ما أنواع االستثمار في المملكة؟ </p>
                            <div class="d-flex align-items-baseline mrr-4">
                                <div>
                                    <div class="list-dot"></div>
                                </div>
                                <p class="pdf-text"> اطلـع علـى اإلرشـادات والتوجيهـات فـي حقيبـة المـدرب، فهـي ستسـاهم
                                    بـإذن اللـه فـي
                                    توضيـح
                                    مـا</p>
                            </div>
                            <div class="d-flex align-items-baseline mrr-4">
                                <div>
                                    <div class="list-dot"></div>
                                </div>
                                <p class="pdf-text"> اطلـع علـى اإلرشـادات والتوجيهـات فـي حقيبـة المـدرب، فهـي ستسـاهم
                                    بـإذن اللـه فـي
                                    توضيـح
                                    مـا</p>
                            </div>
                            <p class="pdf-text">ما أنواع االستثمار في المملكة؟ </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="container max-w-h bg-white-pdf my-2">
        <div class="p-pdf-bottom">
            <div class="d-flex p-6rem">
                <img class="pdf-page-logo" src="../../../../assets/new-logo/SCBCLOGO-COLOR.svg" alt="loading">
                <div class="b-bottom"></div>
            </div>
            <div class="px-5rem">
                <div class="bf-box pos-rel-pdf mtt-3rem">
                    <div class="d-flex pos-abs-bf">
                        <img class="pen-icon" src="../../../../assets/icons/Email/24@1.5x.svg" alt="loading">
                        <div class="bf-text">
                            اإلجابة النموذجية
                        </div>
                    </div>
                    <div class="d-flex">
                        <div class="col-boxes-w-25">
                            <div class="col-boxes">
                                <p class="pdf-text">الترخيص الزراعي: </p>
                            </div>
                        </div>
                        <div class="col-boxes-w-75">
                            <div class="col-boxes">
                                <p class="pdf-text">يتم إصدار هذا الترخيص للشركات التي تقدم خدمات االستشارة
                                    الهندسية في المملكة العربية السعودية.</p>
                            </div>
                        </div>
                    </div>
                    <div class="d-flex">
                        <div class="col-boxes-w-25">
                            <div class="col-boxes">
                                <p class="pdf-text">الترخيص الزراعي: </p>
                            </div>
                        </div>
                        <div class="col-boxes-w-75">
                            <div class="col-boxes">
                                <p class="pdf-text">يتم إصدار هذا الترخيص للشركات التي تقدم خدمات االستشارة
                                    الهندسية في المملكة العربية السعودية.</p>
                            </div>
                        </div>
                    </div>
                    <div class="d-flex">
                        <div class="col-boxes-w-25">
                            <div class="col-boxes">
                                <p class="pdf-text">الترخيص الزراعي: </p>
                            </div>
                        </div>
                        <div class="col-boxes-w-75">
                            <div class="col-boxes">
                                <p class="pdf-text">يتم إصدار هذا الترخيص للشركات التي تقدم خدمات االستشارة
                                    الهندسية في المملكة العربية السعودية.</p>
                            </div>
                        </div>
                    </div>
                    <div class="d-flex">
                        <div class="col-boxes-w-25">
                            <div class="col-boxes">
                                <p class="pdf-text">الترخيص الزراعي: </p>
                            </div>
                        </div>
                        <div class="col-boxes-w-75">
                            <div class="col-boxes">
                                <p class="pdf-text">يتم إصدار هذا الترخيص للشركات التي تقدم خدمات االستشارة
                                    الهندسية في المملكة العربية السعودية.</p>
                            </div>
                        </div>
                    </div>
                    <div class="d-flex">
                        <div class="col-boxes-w-25">
                            <div class="col-boxes">
                                <p class="pdf-text">الترخيص الزراعي: </p>
                            </div>
                        </div>
                        <div class="col-boxes-w-75">
                            <div class="col-boxes">
                                <p class="pdf-text">يتم إصدار هذا الترخيص للشركات التي تقدم خدمات االستشارة
                                    الهندسية في المملكة العربية السعودية.</p>
                            </div>
                        </div>
                    </div>
                    <h6 class="pdf-heading-sky-mini my-2">عزيزي المدرب: </h6>
                    <div class="d-flex align-items-baseline mrr-4">
                        <div>
                            <div class="list-dot"></div>
                        </div>
                        <p class="pdf-text">حقيبـة المـدرب، فهـي ستسـاهم بـإذن اللـه فـي توضيـح
                            مـا</p>
                    </div>
                    <div class="d-flex align-items-baseline mrr-4">
                        <div>
                            <div class="list-dot"></div>
                        </div>
                        <p class="pdf-text"> اطلـع علـى اإلرشـاداتحقيبـةاللـه فـي توضيـح
                            مـا</p>
                    </div>
                    <div class="d-flex align-items-baseline mrr-4">
                        <div>
                            <div class="list-dot"></div>
                        </div>
                        <p class="pdf-text"> اطلـع علـى اإلرشـادات والتوجيهـات فـي حقيبـة المـدرب،اللـه فـي
                            مـا</p>
                    </div>

                </div>
            </div>
        </div>
    </div>

    <div class="container max-w-h bg-white-pdf my-2">
        <div class="p-pdf-bottom">
            <div class="d-flex p-6rem">
                <img class="pdf-page-logo" src="../../../../assets/new-logo/SCBCLOGO-COLOR.svg" alt="loading">
                <div class="b-bottom"></div>
            </div>
            <div class="px-5rem">
                <div class="d-flex justify-content-center">
                    <h6 class="pdf-heading mb-3rem">خالصة الجلسة التدريبية</h6>
                </div>
                <div class="d-flex align-items-baseline">
                    <div>
                        <div class="list-dot"></div>
                    </div>
                    <p class="pdf-text">تطــور تنظيــم االســتثمار فــي المملكــة بشــكل متســارع فــي الفتــرة
                        األخيــرة؛ حيــث
                        يتضــح تنــوع
                        وانفتــاح االقتصــاد فــي المملكــة وتطــور التشــريعات المنظمــة لالســتثمار، إضافــة إلــى
                        توافــر بيئــة
                        آمنـة ومسـتقرة، كمـا سـعت الـوزارة إلـى تقديـم الخدمـات بشـكل إلكترونـي للمسـتثمرين حسـب نـوع
                        المســتثمر )حالــي، جديــد( وأتمتــة العديــد مــن هــذه الخدمــات لخدمــة المســتثمرين وتســريع
                        إجراءاتهــم.</p>
                </div>
                <!-- space circle diagram start -->
                <div class="container-fluid">
                    <div class="container d-flex justify-content-center my-5">
                        <div class="main-circle-border">
                            <div class="main-circle">
                                <p class="pdf-text-z-index-circle">تطــور تنظيــم االســتثمار فــي</p>
                                <div class="main-circle-inner"></div>
                            </div>

                            <div class="pos-rel-pdf">
                                <div class="mini-circle-pos-abs-1">
                                    <div class="main-circle-mini-1">
                                        <p class="pdf-text-z-index-mini-1">تطــور تنظيــفــي</p>
                                        <div class="main-circle-mini-1-inner"></div>
                                        <i class="mini-circle-arrow-1 fa-solid fa-arrow-turn-down"></i>
                                    </div>
                                </div>
                                <div class="mini-circle-pos-abs-2">
                                    <div class="main-circle-mini-1">
                                        <p class="pdf-text-z-index-mini-1">تطــور تنظيــفــي</p>
                                        <div class="main-circle-mini-1-inner"></div>
                                        <i class="mini-circle-arrow-2 fa-solid fa-arrow-turn-down"></i>
                                    </div>
                                </div>
                                <div class="mini-circle-pos-abs-3">
                                    <div class="main-circle-mini-1">
                                        <p class="pdf-text-z-index-mini-1">تطــور تنظيــفــي</p>
                                        <div class="main-circle-mini-1-inner"></div>
                                        <i class="mini-circle-arrow-3 fa-solid fa-arrow-turn-down"></i>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- space circle-diagram end -->
            </div>
        </div>
    </div>

    <div class="container max-w-h bg-white-pdf my-2">
        <div class="p-pdf-bottom">
            <div class="px-5rem">
                <div class="d-flex">
                    <div class="b-bottom"></div>
                    <p class="pdf-text-desc">خدمات وزارة االسـتثمار</p>
                </div>
                <div class="d-flex align-items-baseline mtt-3rem">
                    <div>
                        <div class="sky-num">1.</div>
                    </div>
                    <p class="pdf-text">اطلــع علــى المــادة العلميــة بعنــوان )نبــذة عــن وزارة االســتثمار(، وســجل
                        اســمك
                        ومعلومــة أثــارت
                        انتباهــك عــن الــوزارة فــي إحــدى األوراق الالصقــة وعلقهــا علــى لوحــة العــرض</p>
                </div>

                <div class="my-5">
                    <div class="d-flex">
                        <div class="col-boxes-w-25 bg-25">
                            الترخيص الزراعي:
                        </div>
                        <div class="col-boxes-w-75 bg-25">
                            يتم إصدار هذا الترخيص للشركات التي تقدم خدمات االستشارة
                            الهندسية في المملكة العربية السعودية.
                        </div>
                    </div>
                    <div class="d-flex">
                        <div class="col-boxes-w-25">
                            <div class="col-boxes">
                                <p class="pdf-text">الترخيص الزراعي: </p>
                            </div>
                        </div>
                        <div class="col-boxes-w-75">
                            <div class="col-boxes">
                                <p class="pdf-text">يتم إصدار هذا الترخيص للشركات التي تقدم خدمات االستشارة
                                    الهندسية في المملكة العربية السعودية.</p>
                            </div>
                        </div>
                    </div>
                    <div class="d-flex">
                        <div class="col-boxes-w-25">
                            <div class="col-boxes">
                                <p class="pdf-text">الترخيص الزراعي: </p>
                            </div>
                        </div>
                        <div class="col-boxes-w-75">
                            <div class="col-boxes">
                                <p class="pdf-text">يتم إصدار هذا الترخيص للشركات التي تقدم خدمات االستشارة
                                    الهندسية في المملكة العربية السعودية.</p>
                            </div>
                        </div>
                    </div>
                    <div class="d-flex">
                        <div class="col-boxes-w-25">
                            <div class="col-boxes">
                                <p class="pdf-text">الترخيص الزراعي: </p>
                            </div>
                        </div>
                        <div class="col-boxes-w-75">
                            <div class="col-boxes">
                                <p class="pdf-text">يتم إصدار هذا الترخيص للشركات التي تقدم خدمات االستشارة
                                    الهندسية في المملكة العربية السعودية.</p>
                            </div>
                        </div>
                    </div>
                    <div class="d-flex">
                        <div class="col-boxes-w-25">
                            <div class="col-boxes">
                                <p class="pdf-text">الترخيص الزراعي: </p>
                            </div>
                        </div>
                        <div class="col-boxes-w-75">
                            <div class="col-boxes">
                                <p class="pdf-text">يتم إصدار هذا الترخيص للشركات التي تقدم خدمات االستشارة
                                    الهندسية في المملكة العربية السعودية.</p>
                            </div>
                        </div>
                    </div>
                    <div class="d-flex">
                        <div class="col-boxes-w-25">
                            <div class="col-boxes">
                                <p class="pdf-text">الترخيص الزراعي: </p>
                            </div>
                        </div>
                        <div class="col-boxes-w-75">
                            <div class="col-boxes">
                                <p class="pdf-text">يتم إصدار هذا الترخيص للشركات التي تقدم خدمات االستشارة
                                    الهندسية في المملكة العربية السعودية.</p>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>

    <div class="container max-w-h bg-white-pdf my-2">
        <div class="p-pdf-bottom">
            <div class="px-5rem">
                <div class="d-flex">
                    <div class="b-bottom"></div>
                    <p class="pdf-text-desc">خدمات وزارة االسـتثمار</p>
                </div>
                <!-- logo and detail section start -->
                <div class="d-flex justify-content-center my-5">
                    <h6 class="pdf-heading">خالصة الجلسة التدريبية</h6>
                </div>
                <h6 class="pdf-heading-sky-mini">رحلة المستثمر:</h6>
                <div class="d-flex">
                    <p class="pdf-text-sky">المرحلة األولى:&nbsp;</p>
                    <p class="pdf-text">إصدار ترخيص االستثمار</p>
                </div>
                <p class="pdf-text-bold">المتطلبات:</p>
                <div class="d-flex align-items-baseline">
                    <div>
                        <div class="list-dot"></div>
                    </div>
                    <p class="pdf-text">اطلــع علــى المــادة العلميــة بعنــوان )نبــذة عــن </p>
                </div>
                <div class="d-flex align-items-baseline">
                    <div>
                        <div class="list-dot"></div>
                    </div>
                    <p class="pdf-text"> علــى المــادة العلميــة بعنــوان</p>
                </div>
                <p class="pdf-text-bold">الجهة المسؤولة: </p>

                <div class="d-flex justify-content-start align-items-center flex-wrap">
                    <div class="sbc-img">
                        <img class="sbc-img-size" src="../../../../assets/nelcLogo2020.png" alt="loading">
                    </div>
                    <div class="sbc-img">
                        <img class="sbc-img-size" src="../../../../assets/PRC1.png" alt="loading">
                    </div>
                </div>
                <!-- logo and detail section end -->
                <!-- logo and detail section start -->
                <h6 class="pdf-heading-sky-mini">رحلة المستثمر:</h6>
                <div class="d-flex">
                    <p class="pdf-text-sky">المرحلة األولى:&nbsp;</p>
                    <p class="pdf-text">إصدار ترخيص االستثمار</p>
                </div>
                <p class="pdf-text-bold">المتطلبات:</p>
                <div class="d-flex align-items-baseline">
                    <div>
                        <div class="list-dot"></div>
                    </div>
                    <p class="pdf-text">اطلــع علــى المــادة العلميــة بعنــوان )نبــذة عــن </p>
                </div>
                <div class="d-flex align-items-baseline">
                    <div>
                        <div class="list-dot"></div>
                    </div>
                    <p class="pdf-text"> علــى المــادة العلميــة بعنــوان</p>
                </div>
                <p class="pdf-text-bold">الجهة المسؤولة: </p>

                <div class="d-flex justify-content-start align-items-center flex-wrap">
                    <div class="sbc-img">
                        <img class="sbc-img-size" src="../../../../assets/nelcLogo2020.png" alt="loading">
                    </div>
                    <div class="sbc-img">
                        <img class="sbc-img-size" src="../../../../assets/PRC1.png" alt="loading">
                    </div>
                    <div class="sbc-img">
                        <img class="sbc-img-size" src="../../../../assets/logo.png" alt="loading">
                    </div>
                </div>
                <!-- logo and detail section end -->
                <!-- logo and detail section start -->
                <h6 class="pdf-heading-sky-mini">رحلة المستثمر:</h6>
                <div class="d-flex">
                    <p class="pdf-text-sky">المرحلة األولى:&nbsp;</p>
                    <p class="pdf-text">إصدار ترخيص االستثمار</p>
                </div>
                <p class="pdf-text-bold">المتطلبات:</p>
                <div class="d-flex align-items-baseline">
                    <div>
                        <div class="list-dot"></div>
                    </div>
                    <p class="pdf-text">اطلــع علــى المــادة العلميــة بعنــوان )نبــذة عــن </p>
                </div>
                <div class="d-flex align-items-baseline">
                    <div>
                        <div class="list-dot"></div>
                    </div>
                    <p class="pdf-text">اطلــع علــى المــادة العلميــة بعنــوان )نبــذة عــن </p>
                </div>
                <div class="d-flex align-items-baseline">
                    <div>
                        <div class="list-dot"></div>
                    </div>
                    <p class="pdf-text">اطلــع علــى المــادة العلميــة بعنــوان )نبــذة عــن </p>
                </div>
                <div class="d-flex align-items-baseline">
                    <div>
                        <div class="list-dot"></div>
                    </div>
                    <p class="pdf-text"> علــى المــادة العلميــة بعنــوان</p>
                </div>
                <p class="pdf-text-bold">الجهة المسؤولة: </p>

                <div class="d-flex justify-content-start align-items-center flex-wrap">
                    <div class="sbc-img">
                        <img class="sbc-img-size" src="../../../../assets/logo.png" alt="loading">
                    </div>
                    <div class="sbc-img">
                        <img class="sbc-img-size" src="../../../../assets/btn 1.png" alt="loading">
                    </div>
                </div>
                <!-- logo and detail section end -->


            </div>
        </div>
    </div>

    <div class="container max-w-h bg-white-pdf my-2">
        <div class="p-pdf-bottom">
            <div class="d-flex p-6rem">
                <img class="pdf-page-logo" src="../../../../assets/new-logo/SCBCLOGO-COLOR.svg" alt="loading">
                <div class="b-bottom"></div>
            </div>
            <div class="px-5rem">
                <div class="d-flex justify-content-center">
                    <h6 class="pdf-heading mb-3rem">تصنيف خدمات وزارة االستثمار
                    </h6>
                </div>
                <div class="row p-0">
                    <div class="col-md-6 pr-3rem">
                        <h6 class="pdf-heading-sky-mini">إصدار التراخيص: </h6>
                        <div class="d-flex align-items-baseline mrr-4">
                            <div>
                                <div class="list-dot"></div>
                            </div>
                            <p class="pdf-text">الترخيص الصناعي.</p>
                        </div>
                        <div class="d-flex align-items-baseline mrr-4">
                            <div>
                                <div class="list-dot"></div>
                            </div>
                            <p class="pdf-text">الترخيص الصناعي.</p>
                        </div>
                        <div class="d-flex align-items-baseline mrr-4">
                            <div>
                                <div class="list-dot"></div>
                            </div>
                            <p class="pdf-text">الترخيص الصناعي.</p>
                        </div>
                        <div class="d-flex align-items-baseline mrr-4">
                            <div>
                                <div class="list-dot"></div>
                            </div>
                            <p class="pdf-text">الترخيص الصناعي.</p>
                        </div>
                        <div class="d-flex align-items-baseline mrr-4">
                            <div>
                                <div class="list-dot"></div>
                            </div>
                            <p class="pdf-text">الترخيص الصناعي.</p>
                        </div>
                        <div class="d-flex align-items-baseline mrr-4">
                            <div>
                                <div class="list-dot"></div>
                            </div>
                            <p class="pdf-text"> ترخيص تجاري بشريك سعودي</p>
                        </div>
                        <div class="d-flex align-items-baseline mrr-4">
                            <div>
                                <div class="list-dot"></div>
                            </div>
                            <p class="pdf-text">ترخيص مكتب علمي وفني.</p>
                        </div>
                        <div class="d-flex align-items-baseline mrr-4">
                            <div>
                                <div class="list-dot"></div>
                            </div>
                            <p class="pdf-text">شهادة مؤقتة للتقديم
                                على عطاءات المشاريع
                                الحكومية.</p>
                        </div>
                        <div class="d-flex align-items-baseline mrr-4">
                            <div>
                                <div class="list-dot"></div>
                            </div>
                            <p class="pdf-text">إصــدار ترخيــص مؤقــت </p>
                        </div>
                        <div class="d-flex align-items-baseline mrr-4">
                            <div>
                                <div class="list-dot"></div>
                            </div>
                            <p class="pdf-text">نفيــذ عقــد حكومــي/ شــبه
                                حكومــي واحــد.</p>
                        </div>
                    </div>
                    <div class="col-md-6 p-0">
                        <!-- second space circle diagram start -->
                        <div class="container-fluid">
                            <div class="container d-flex justify-content-end  my-5">
                                <div class="main-circle-border-2nd-space">
                                    <div class="main-circle-2nd-space">
                                        <p class="pdf-text-z-index-circle-2nd-space">تطــور تنظيــم االســتثمار فــي</p>
                                        <div class="main-circle-inner-2nd-space"></div>
                                    </div>

                                    <div class="pos-rel-pdf">
                                        <div class="mini-circle-pos-abs-1-2nd-space">
                                            <div class="pos-rel-pdf">
                                                <div class="mini-circle-num-pos-abs">
                                                    <span class="mini-num-zindex">1</span>
                                                </div>
                                            </div>
                                            <div class="main-circle-mini-1-2nd-space">
                                                <p class="pdf-text-z-index-mini-1-2nd-space">إصدار
                                                    التراخيص
                                                </p>
                                                <div class="main-circle-mini-1-inner-2nd-space"></div>
                                            </div>
                                        </div>

                                        <div class="mini-circle-pos-abs-2-2nd-space">
                                            <div class="pos-rel-pdf">
                                                <div class="mini-circle-num-pos-abs">
                                                    <span class="mini-num-zindex">2</span>
                                                </div>
                                            </div>
                                            <div class="main-circle-mini-1-2nd-space">
                                                <p class="pdf-text-z-index-mini-1-2nd-space">تعديل
                                                    التراخيص
                                                </p>
                                                <div class="main-circle-mini-1-inner-2nd-space"></div>
                                            </div>
                                        </div>

                                        <div class="mini-circle-pos-abs-3-2nd-space">
                                            <div class="pos-rel-pdf">
                                                <div class="mini-circle-num-pos-abs">
                                                    <span class="mini-num-zindex">3</span>
                                                </div>
                                            </div>
                                            <div class="main-circle-mini-1-2nd-space">
                                                <p class="pdf-text-z-index-mini-1-2nd-space">تجديد
                                                    التراخيص</p>
                                                <div class="main-circle-mini-1-inner-2nd-space"></div>
                                            </div>
                                        </div>

                                        <div class="mini-circle-pos-abs-4-2nd-space">
                                            <div class="pos-rel-pdf">
                                                <div class="mini-circle-num-pos-abs">
                                                    <span class="mini-num-zindex">4</span>
                                                </div>
                                            </div>
                                            <div class="main-circle-mini-1-2nd-space">
                                                <p class="pdf-text-z-index-mini-1-2nd-space">تملك وبيع
                                                    العقار
                                                </p>
                                                <div class="main-circle-mini-1-inner-2nd-space"></div>
                                            </div>
                                        </div>

                                        <div class="mini-circle-pos-abs-5-2nd-space">
                                            <div class="pos-rel-pdf">
                                                <div class="mini-circle-num-pos-abs">
                                                    <span class="mini-num-zindex">5</span>
                                                </div>
                                            </div>
                                            <div class="main-circle-mini-1-2nd-space">
                                                <p class="pdf-text-z-index-mini-1-2nd-space">تحويل
                                                    التراخيص الى
                                                    وطني 100 %
                                                </p>
                                                <div class="main-circle-mini-1-inner-2nd-space"></div>
                                            </div>
                                        </div>

                                        <div class="mini-circle-pos-abs-6-2nd-space">
                                            <div class="pos-rel-pdf">
                                                <div class="mini-circle-num-pos-abs">
                                                    <span class="mini-num-zindex">6</span>
                                                </div>
                                            </div>
                                            <div class="main-circle-mini-1-2nd-space">
                                                <p class="pdf-text-z-index-mini-1-2nd-space">إلغاء
                                                    الترخيص</p>
                                                <div class="main-circle-mini-1-inner-2nd-space"></div>
                                            </div>
                                        </div>

                                        <div class="mini-circle-pos-abs-7-2nd-space">
                                            <div class="pos-rel-pdf">
                                                <div class="mini-circle-num-pos-abs">
                                                    <span class="mini-num-zindex">7</span>
                                                </div>
                                            </div>
                                            <div class="main-circle-mini-1-2nd-space">
                                                <p class="pdf-text-z-index-mini-1-2nd-space">خدمات وزارة
                                                    االستثمار الخاصة
                                                    بمركز خدمات
                                                    المستثمرين</p>
                                                <div class="main-circle-mini-1-inner-2nd-space"></div>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                        <!-- second space circle-diagram end -->
                    </div>
                </div>
                <div class="d-flex flex-column">
                    <div class="d-flex align-items-baseline mrr-1-3">
                        <div>
                            <div class="list-dot"></div>
                        </div>
                        <p class="pdf-text">خدمة إصدار ترخيص النقل العام البري بواسطة القطارات المترو داخل المدن.</p>
                    </div>
                    <div class="d-flex align-items-baseline mrr-1-3">
                        <div>
                            <div class="list-dot"></div>
                        </div>
                        <p class="pdf-text">خدمة إصدار ترخيص النقل العام البري بالحافالت داخل المدن.</p>
                    </div>
                    <div class="d-flex align-items-baseline mrr-1-3">
                        <div>
                            <div class="list-dot"></div>
                        </div>
                        <p class="pdf-text">الترخيص للمستفيدين من الحملة التصحيحية للبرنامج الوطني لمكافحة التستر
                            التجاري.</p>
                    </div>
                    <div class="d-flex align-items-baseline mrr-1-3">
                        <div>
                            <div class="list-dot"></div>
                        </div>
                        <p class="pdf-text">ترخيص نشاط وكالء االستقدام وتأجير خدمات العمالة المنزلية.</p>
                    </div>
                    <div class="d-flex align-items-baseline mrr-1-3">
                        <div>
                            <div class="list-dot"></div>
                        </div>
                        <p class="pdf-text">خدمة إصدار ترخيص النقل العام البري بواسطة القطارات المترو داخل المدن.</p>
                    </div>
                    <div class="d-flex align-items-baseline mrr-1-3">
                        <div>
                            <div class="list-dot"></div>
                        </div>
                        <p class="pdf-text">خدمة إصدار ترخيص النقل العام البري بالحافالت داخل المدن.</p>
                    </div>
                    <div class="d-flex align-items-baseline mrr-1-3">
                        <div>
                            <div class="list-dot"></div>
                        </div>
                        <p class="pdf-text">الترخيص للمستفيدين من الحملة التصحيحية للبرنامج الوطني لمكافحة التستر
                            التجاري.</p>
                    </div>
                    <div class="d-flex align-items-baseline mrr-1-3">
                        <div>
                            <div class="list-dot"></div>
                        </div>
                        <p class="pdf-text">ترخيص نشاط وكالء االستقدام وتأجير خدمات العمالة المنزلية.</p>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="container max-w-h bg-white-pdf my-2">
        <div class="p-pdf-bottom">
            <div class="d-flex p-6rem">
                <img class="pdf-page-logo" src="../../../../assets/new-logo/SCBCLOGO-COLOR.svg" alt="loading">
                <div class="b-bottom"></div>
            </div>
            <div class="px-5rem">
                <div class="bf-box pos-rel-pdf mtt-3rem">
                    <div class="d-flex pos-abs-bf">
                        <img class="pen-icon" src="../../../../assets/icons/Email/24@1.5x.svg" alt="loading">
                        <div class="bf-text">
                            اإلجابة النموذجية
                        </div>
                    </div>
                    <div class="grey-box-pdf my-3">
                        <div class="border-box-pdf">
                            <div class="d-flex justify-content-center pos-rel-pdf">
                                <div class="border-heading">
                                    مجموعة أنواع االستثمار
                                </div>
                            </div>
                            <p class="pdf-text my-3">ما أنواع االستثمار في المملكة؟ </p>
                            <div class="d-flex flex-column">
                                <div class="d-flex flex-column mrr-4">
                                    <div class="d-flex align-items-baseline">
                                        <div class="d-flex">
                                            <div class="list-dot"></div>
                                        </div>
                                        <p class="pdf-text">جـوز للمكتـب دراسـة األسـواق بالنسـبة لنـوع نشـاط الشــركة،
                                            ويمكـن إعـداد
                                            تقاريـر
                                            ً عـن هـذه الدراسـة للمركـز الرئيـس، وعلـى المكتـب أن يقـدم لوزارة
                                            االسـتثمار ملخصا
                                            ً سـنويا عـن نشـاطه. </p>
                                    </div>
                                    <div class="d-flex align-items-baseline mrr-4">
                                        <div>
                                            <div class="border-dot"></div>
                                        </div>
                                        <p class="pdf-text"> اطلـع علـى اإلرشـادات</p>
                                    </div>
                                    <div class="d-flex align-items-baseline mrr-4">
                                        <div>
                                            <div class="border-dot"></div>
                                        </div>
                                        <p class="pdf-text"> اطلـع علـى اإلرشـادات</p>
                                    </div>
                                    <div class="d-flex align-items-baseline mrr-4">
                                        <div>
                                            <div class="border-dot"></div>
                                        </div>
                                        <p class="pdf-text"> اطلـع علـى اإلرشـادات</p>
                                    </div>
                                </div>
                            </div>
                            <p class="pdf-text">ما أنواع االستثمار في المملكة؟ </p>

                        </div>
                    </div>
                    <div class="grey-box-pdf my-3">
                        <div class="border-box-pdf">
                            <div class="d-flex justify-content-center pos-rel-pdf">
                                <div class="border-heading">
                                    مجموعة أنواع االستثمار
                                </div>
                            </div>
                            <p class="pdf-text my-3">ما أنواع االستثمار في المملكة؟ </p>
                            <div class="d-flex flex-column">
                                <div class="d-flex flex-column mrr-4">
                                    <div class="d-flex align-items-baseline">
                                        <div class="d-flex">
                                            <div class="list-dot"></div>
                                        </div>
                                        <p class="pdf-text">جـوز للمكتـب دراسـة األسـواق بالنسـبة لنـوع نشـاط الشــركة،
                                            ويمكـن إعـداد
                                            تقاريـر
                                            ً عـن هـذه الدراسـة للمركـز الرئيـس، وعلـى المكتـب أن يقـدم لوزارة
                                            االسـتثمار ملخصا
                                            ً سـنويا عـن نشـاطه. </p>
                                    </div>
                                    <div class="d-flex align-items-baseline mrr-4">
                                        <div>
                                            <div class="border-dot"></div>
                                        </div>
                                        <p class="pdf-text"> اطلـع علـى اإلرشـادات</p>
                                    </div>
                                    <div class="d-flex align-items-baseline mrr-4">
                                        <div>
                                            <div class="border-dot"></div>
                                        </div>
                                        <p class="pdf-text"> اطلـع علـى اإلرشـادات</p>
                                    </div>
                                    <div class="d-flex align-items-baseline mrr-4">
                                        <div>
                                            <div class="border-dot"></div>
                                        </div>
                                        <p class="pdf-text"> اطلـع علـى اإلرشـادات</p>
                                    </div>
                                </div>
                            </div>
                            <p class="pdf-text">ما أنواع االستثمار في المملكة؟ </p>
                        </div>
                    </div>
                    <div class="grey-box-pdf my-3">
                        <div class="border-box-pdf">
                            <div class="d-flex justify-content-center pos-rel-pdf">
                                <div class="border-heading">
                                    مجموعة الكيانات القانونية األكثر طلبا لتراخيص
                                    االستثمار في وزارة االستثمار
                                </div>
                            </div>
                            <p class="pdf-text my-3">ما أنواع االستثمار في المملكة؟ </p>
                            <div class="d-flex flex-column">
                                <div class="d-flex flex-column mrr-4">
                                    <div class="d-flex align-items-baseline">
                                        <div class="d-flex">
                                            <div class="list-dot"></div>
                                        </div>
                                        <p class="pdf-text">جـوز للمكتـب دراسـة األسـواق بالنسـبة لنـوع نشـاط الشــركة،
                                            ويمكـن إعـداد
                                            تقاريـر
                                            ً عـن هـذه الدراسـة للمركـز الرئيـس، وعلـى المكتـب أن يقـدم لوزارة
                                            االسـتثمار ملخصا
                                            ً سـنويا عـن نشـاطه. </p>
                                    </div>
                                    <div class="d-flex align-items-baseline mrr-4">
                                        <div>
                                            <div class="border-dot"></div>
                                        </div>
                                        <p class="pdf-text"> اطلـع علـى اإلرشـادات</p>
                                    </div>
                                    <div class="d-flex align-items-baseline mrr-4">
                                        <div>
                                            <div class="border-dot"></div>
                                        </div>
                                        <p class="pdf-text"> اطلـع علـى اإلرشـادات</p>
                                    </div>
                                    <div class="d-flex align-items-baseline mrr-4">
                                        <div>
                                            <div class="border-dot"></div>
                                        </div>
                                        <p class="pdf-text"> اطلـع علـى اإلرشـادات</p>
                                    </div>
                                </div>
                            </div>
                            <p class="pdf-text">ما أنواع االستثمار في المملكة؟ </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="container max-w-h bg-white-pdf my-2">
        <div class="p-pdf-bottom">
            <div class="d-flex p-6rem">
                <img class="pdf-page-logo" src="../../../../assets/new-logo/SCBCLOGO-COLOR.svg" alt="loading">
                <div class="b-bottom"></div>
            </div>
            <!-- Profile bar sectio start -->
            <div class="d-flex w-100">
                <div class="">
                    <div class="d-flex">
                        <div class="pdf-profile pos-rel-pdf">
                            <img class="pdf-pp"
                                src="https://media.istockphoto.com/id/2061466428/photo/mid-century-modern-dining-area.webp?a=1&b=1&s=612x612&w=0&k=20&c=U1dsdSCgvYwZdGxcWRA3Z_WiF34-1aK98p5BK6mnko0="
                                alt="loading">
                        </div>
                    </div>
                </div>
                <div class="w-100">
                    <div class="d-flex align-items-baseline">
                        <div class="pp-bar-width-rel">
                            <div class="pp-bar-abs"></div>
                        </div>
                        <div class="d-flex flex-column w-100px">
                            <img class="pp-bar-icon" src="../../../../assets/icons/SBC/clock.svg" alt="loading">
                            <h6 class="pp-bar-text">10 دقيقة</h6>
                        </div>
                        <div class="pp-bar-width-rel">
                            <div class="pp-bar-abs"></div>
                        </div>
                        <div class="d-flex flex-column w-100px">
                            <img class="pp-bar-icon" src="../../../../assets/icons/SBC/clock.svg" alt="loading">
                            <h6 class="pp-bar-text">10 دقيقة</h6>
                        </div>
                    </div>
                    <div class="bar-2-reponse">
                        <div class="bar-2">
                            <img class="pp-bar-icon" src="../../../../assets/icons/SBC/clock.svg" alt="loading">
                            الحوار والمناقشة
                        </div>
                        <div class="bar-2">
                            <img class="pp-bar-icon" src="../../../../assets/icons/SBC/clock.svg" alt="loading">
                            المحاضرة
                        </div>
                        <div class="bar-2">
                            <img class="pp-bar-icon" src="../../../../assets/icons/SBC/clock.svg" alt="loading">
                            بطاقات تدريبية
                        </div>
                    </div>
                    <div class="d-flex">
                        <div class="d-flex flex-column">
                            <div class="bar-3">
                                نشاط
                            </div>
                            <div class="bar-3-num">1</div>
                        </div>
                        <div class="bar-3-blu-box">
                            نبذة عن وزارة االستثمار.
                        </div>
                    </div>
                </div>
            </div>
            <!-- Profile bar sectio end -->
            <div class="pos-rel-pdf">
                <div class="bar-logo">
                    <img class="bar-logo-img" src="../../../../assets/icons/SBC/mountain.svg" alt="loading">
                </div>
            </div>
            <div class="d-flex justify-content-center flex-column align-items-center mtt-3rem">
                <div class="bar-max-width">
                    <div>
                        <h6 class="pdf-heading-blue-mini">مع نهاية هذا النشاط بإذن الله، ستكون قادرا على أن:</h6>
                    </div>
                    <div class="d-flex align-items-baseline">
                        <div>
                            <div class="list-dot mrr-4"></div>
                        </div>
                        <p class="pdf-text">اإلرشـادات والتوجيهـات وضِ عـت لمسـاعدتك فـي</p>
                    </div>
                </div>
            </div>
            <div class="px-5rem">
                <div class="d-flex">
                    <div class="d-flex align-items-baseline">
                        <div>
                            <div class="sky-num">1.</div>
                        </div>
                        <p class="pdf-text">اطلــع علــى المــادة العلميــة بعنــوان )نبــذة عــن وزارة االســتثمار(،
                            وســجل اســمك
                            ومعلومــة أثــارت
                            انتباهــك عــن الــوزارة فــي إحــدى األوراق الالصقــة وعلقهــا علــى لوحــة العــرض</p>
                    </div>
                    <div>
                        <img class="qr-code-2"
                            src="https://media.istockphoto.com/id/828088276/vector/qr-code-illustration.jpg?s=612x612&w=0&k=20&c=FnA7agr57XpFi081ZT5sEmxhLytMBlK4vzdQxt8A70M="
                            alt="loading">
                    </div>
                </div>
                <div class="d-flex align-items-baseline">
                    <div>
                        <div class="list-dot"></div>
                    </div>
                    <p class="pdf-text">اإلرشـادات والتوجيهـات وضِ عـت لمسـاعدتك فـي تنفيـذ األنشـطة</p>
                </div>
                <div class="d-flex flex-column">
                    <div class="papper-dotts"></div>
                    <div class="papper-dotts"></div>
                    <div class="papper-dotts"></div>
                    <div class="papper-dotts"></div>
                    <div class="papper-dotts"></div>
                    <div class="papper-dotts"></div>
                </div>
                <div class="d-flex align-items-baseline">
                    <div>
                        <div class="list-dot"></div>
                    </div>
                    <p class="pdf-text">اإلرشـادات والتوجيهـات وضِ عـت لمسـاعدتك فـي تنفيـذ األنشـطة</p>
                </div>
                <div class="d-flex flex-column">
                    <div class="papper-dotts"></div>
                    <div class="papper-dotts"></div>
                    <div class="papper-dotts"></div>
                    <div class="papper-dotts"></div>
                    <div class="papper-dotts"></div>
                    <div class="papper-dotts"></div>
                </div>
            </div>
        </div>
    </div>

    <div class="container max-w-h bg-white-pdf my-2">
        <div class="p-pdf-bottom">
            <div class="px-6rem">
                <div class="d-flex">
                    <img class="pdf-page-logo" src="../../../../assets/new-logo/SCBCLOGO-COLOR.svg" alt="loading">
                    <div class="b-bottom"></div>
                </div>
                <div class="d-flex mtt-3rem mb-3rem">
                    <img class="pen-icon" src="../../../../assets/icons/SBC/penpaper.svg" alt="loading">
                    <h6 class="pdf-heading-bg">المراجع والمصادر</h6>
                </div>

                <div class="row p-0">
                    <div class="qr-bar-active">
                        <div class="d-flex align-items-baseline">
                            <div>
                                <div class="sky-num">1.</div>
                            </div>
                            <p class="pdf-text">اطلــع علــى المــادة العلميــة بعنــوان نتباهــك عــن الــوزارة فــي
                                إحــدى األوراق
                                الالصقــة</p>
                        </div>
                    </div>
                    <div class="qr-bar">
                        <div class="d-flex align-items-baseline">
                            <div>
                                <div class="sky-num">1.</div>
                            </div>
                            <p class="pdf-text">اطلــع علــى المــادة العلميــة بعنــوان نتباهــك عــن الــوزارة فــي
                                إحــدى األوراق
                                الالصقــة</p>
                        </div>
                    </div>
                    <div class="col-md-6 d-flex justify-content-center align-items-center qr-bar-col p-0">
                        <div class="d-flex align-items-baseline">
                            <div>
                                <div class="sky-num">1.</div>
                            </div>
                            <p class="pdf-text">اطلــع علــى المــادة العلميــة بعنــوان نتباهــك عــن الــوزارة فــي
                                إحــدى األوراق
                                الالصقــة</p>
                        </div>
                    </div>
                    <div class="col-md-6 p-0">
                        <div class="d-flex justify-content-center align-items-center">
                            <img class="qr-code-3"
                                src="https://media.istockphoto.com/id/828088276/vector/qr-code-illustration.jpg?s=612x612&w=0&k=20&c=FnA7agr57XpFi081ZT5sEmxhLytMBlK4vzdQxt8A70M="
                                alt="loading">
                        </div>
                    </div>
                    <div
                        class="col-md-6 d-flex justify-content-center align-items-center qr-bar-col p-0 qr-bar-col-active">
                        <div class="d-flex align-items-baseline">
                            <div>
                                <div class="sky-num">1.</div>
                            </div>
                            <p class="pdf-text">اطلــع علــى المــادة العلميــة بعنــوان نتباهــك عــن الــوزارة فــي
                                إحــدى األوراق
                                الالصقــة</p>
                        </div>
                    </div>
                    <div class="col-md-6 p-0 qr-bar-col-active">
                        <div class="d-flex justify-content-center align-items-center">
                            <img class="qr-code-3"
                                src="https://media.istockphoto.com/id/828088276/vector/qr-code-illustration.jpg?s=612x612&w=0&k=20&c=FnA7agr57XpFi081ZT5sEmxhLytMBlK4vzdQxt8A70M="
                                alt="loading">
                        </div>
                    </div>
                    <div class="col-md-6 d-flex justify-content-center align-items-center qr-bar-col p-0">
                        <div class="d-flex align-items-baseline">
                            <div>
                                <div class="sky-num">1.</div>
                            </div>
                            <p class="pdf-text">اطلــع علــى المــادة العلميــة بعنــوان نتباهــك عــن الــوزارة فــي
                                إحــدى األوراق
                                الالصقــة</p>
                        </div>
                    </div>
                    <div class="col-md-6 p-0">
                        <div class="d-flex justify-content-center align-items-center">
                            <img class="qr-code-3"
                                src="https://media.istockphoto.com/id/828088276/vector/qr-code-illustration.jpg?s=612x612&w=0&k=20&c=FnA7agr57XpFi081ZT5sEmxhLytMBlK4vzdQxt8A70M="
                                alt="loading">
                        </div>
                    </div>
                    <div class="col-md-6 d-flex justify-content-center align-items-center qr-bar-col p-0">
                        <div class="d-flex align-items-baseline">
                            <div>
                                <div class="sky-num">1.</div>
                            </div>
                            <p class="pdf-text">اطلــع علــى المــادة العلميــة بعنــوان نتباهــك عــن الــوزارة فــي
                                إحــدى األوراق
                                الالصقــة</p>
                        </div>
                    </div>
                    <div class="col-md-6 p-0">
                        <div class="d-flex justify-content-center align-items-center">
                            <img class="qr-code-3"
                                src="https://media.istockphoto.com/id/828088276/vector/qr-code-illustration.jpg?s=612x612&w=0&k=20&c=FnA7agr57XpFi081ZT5sEmxhLytMBlK4vzdQxt8A70M="
                                alt="loading">
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>

    <div class="container max-w-h bg-white-pdf my-2">
        <div class="p-pdf-bottom">
            <div class="px-5rem">
                <div class="d-flex">
                    <img class="pdf-page-logo" src="../../../../assets/new-logo/SCBCLOGO-COLOR.svg" alt="loading">
                    <div class="b-bottom"></div>
                </div>

                <div class="d-flex mtt-3rem mb-3rem">
                    <img class="pen-icon" src="../../../../assets/icons/SBC/penpaper.svg" alt="loading">
                    <h6 class="pdf-heading-bg">مالحظات</h6>
                </div>

                <div class="my-5">
                    <div class="d-flex">
                        <div class="col-boxes-w-75 bg-25">
                            المالحظة
                        </div>
                        <div class="col-boxes-w-25 bg-25">
                            رقم الصفحة
                        </div>
                    </div>
                    <div class="d-flex">
                        <div class="col-boxes-w-75">
                            <div class="col-boxes">
                                <p class="pdf-text">يتم إصدار هذا الترخيص للشركات التي تقدم خدمات االستشارة
                                    الهندسية في المملكة العربية السعودية.</p>
                            </div>
                        </div>
                        <div class="col-boxes-w-25">
                            <div class="col-boxes">
                                <p class="pdf-text">الترخيص الزراعي: </p>
                            </div>
                        </div>
                    </div>
                    <div class="d-flex">
                        <div class="col-boxes-w-75">
                            <div class="col-boxes">
                                <p class="pdf-text">يتم إصدار هذا الترخيص للشركات التي تقدم خدمات االستشارة
                                    الهندسية في المملكة العربية السعودية.</p>
                            </div>
                        </div>
                        <div class="col-boxes-w-25">
                            <div class="col-boxes">
                                <p class="pdf-text">الترخيص الزراعي: </p>
                            </div>
                        </div>
                    </div>
                    <div class="d-flex">
                        <div class="col-boxes-w-75">
                            <div class="col-boxes">
                                <p class="pdf-text">يتم إصدار هذا الترخيص للشركات التي تقدم خدمات االستشارة
                                    الهندسية في المملكة العربية السعودية.</p>
                            </div>
                        </div>
                        <div class="col-boxes-w-25">
                            <div class="col-boxes">
                                <p class="pdf-text">الترخيص الزراعي: </p>
                            </div>
                        </div>
                    </div>
                    <div class="d-flex">
                        <div class="col-boxes-w-75">
                            <div class="col-boxes">
                                <p class="pdf-text">يتم إصدار هذا الترخيص للشركات التي تقدم خدمات االستشارة
                                    الهندسية في المملكة العربية السعودية.</p>
                            </div>
                        </div>
                        <div class="col-boxes-w-25">
                            <div class="col-boxes">
                                <p class="pdf-text">الترخيص الزراعي: </p>
                            </div>
                        </div>
                    </div>
                    <div class="d-flex">
                        <div class="col-boxes-w-75">
                            <div class="col-boxes">
                                <p class="pdf-text">يتم إصدار هذا الترخيص للشركات التي تقدم خدمات االستشارة
                                    الهندسية في المملكة العربية السعودية.</p>
                            </div>
                        </div>
                        <div class="col-boxes-w-25">
                            <div class="col-boxes">
                                <p class="pdf-text">الترخيص الزراعي: </p>
                            </div>
                        </div>
                    </div>
                    <div class="d-flex">
                        <div class="col-boxes-w-75">
                            <div class="col-boxes">
                                <p class="pdf-text">يتم إصدار هذا الترخيص للشركات التي تقدم خدمات االستشارة
                                    الهندسية في المملكة العربية السعودية.</p>
                            </div>
                        </div>
                        <div class="col-boxes-w-25">
                            <div class="col-boxes">
                                <p class="pdf-text">الترخيص الزراعي: </p>
                            </div>
                        </div>
                    </div>
                    <div class="d-flex">
                        <div class="col-boxes-w-75">
                            <div class="col-boxes">
                                <p class="pdf-text">يتم إصدار هذا الترخيص للشركات التي تقدم خدمات االستشارة
                                    الهندسية في المملكة العربية السعودية.</p>
                            </div>
                        </div>
                        <div class="col-boxes-w-25">
                            <div class="col-boxes">
                                <p class="pdf-text">الترخيص الزراعي: </p>
                            </div>
                        </div>
                    </div>

                </div>

            </div>
        </div>
    </div>

    <div class="container max-w-h banner my-2">
        <div class="bg-banner-2 bg-blue d-flex justify-content-center align-items-center">
            <img class="vector" src="../../../../assets/Vector.png" alt="loading">
        </div>
    </div>

    <div class="container max-w-h banner my-2">
        <div class="bg-banner">
            <div class="footer-pdf">

                <div class="d-flex mx-4">
                    <img class="footer-vector" src="../../../../assets/Vector.png" alt="loading">
                </div>

                <div class="d-flex align-items-end flex-column mx-4">
                    <div class="d-flex mb-2">
                        <div class="d-flex align-items-center">
                            <span class="footer-white">199080</span>
                            <i class="mx-2 footer-white fa-brands fa-whatsapp"></i>
                        </div>
                    </div>
                    <div class="d-flex">
                        <div class="d-flex align-items-center">
                            <span class="footer-white">+99611228 2881</span>
                            <i class="mx-2 footer-white fa-solid fa-headphones"></i>
                        </div>
                    </div>
                </div>

                <div class="d-flex align-items-end flex-column mx-4">
                    <div class="d-flex mb-2">
                        <div class="d-flex align-items-center mll-2">
                            <span class="footer-white">BUSINESS.SA</span>
                            <i class="mx-2 footer-white fa-solid fa-globe"></i>
                        </div>
                        <div class="d-flex align-items-center">
                            <span class="footer-white">BCGOV_SA</span>
                            <i class="mx-2 footer-white pi pi-twitter"></i>
                        </div>
                    </div>
                    <div class="d-flex">
                        <div class="d-flex align-items-center">
                            <span class="footer-white">SAUDI BUSINESS CENTER</span>
                            <i class="mx-1 footer-white fa-brands fa-instagram"></i>
                            <i class="mx-1 footer-white fa-brands fa-linkedin"></i>
                            <i class="mx-1 footer-white fa-brands fa-youtube"></i>
                        </div>
                    </div>
                </div>

            </div>

        </div>
    </div>


</div>